
const FREE_SHIP=55; // = valore REALE della tariffa Shopify (zona Italia: gratis da 55,00 EUR). Se cambia in admin, cambialo qui.
// TODO prezzi da confermare (stima ~22-25 eu/500 ml)
// Linea condivisa — fatti comuni a tutti gli oli (fonte unica)
const LINEA={
  origine:"Piana di Macchia, ai piedi del Monte Sant'Angelo, Gargano, Puglia",
  processo:["Raccolta a mano","Molitura entro 12 ore","Spremitura a freddo (sotto i 27°)","30 ettari, alberi secolari"],
  /* la certificazione NON e' della linea ma del singolo olio: sta dentro PRODUCTS.
     Nelle brand-guidelines il BIO e' dichiarato solo per Origine. */
  formato:"500 ml",
  /* NIENTE claim salutistici finche' non c'e' il referto. Le indicazioni sulla salute per i
     polifenoli dell'olio d'oliva sono ammesse solo nella formulazione del Reg. UE 432/2012 e solo
     sopra una soglia misurata di idrossitirosolo: senza analisi non si possono usare.
     Questa e' una descrizione sensoriale, non un'indicazione di salute. */
  assaggio:"Amaro e piccante non sono difetti: sono il segno di un olio appena franto.",
  sostenibilita:["Packaging riciclabile, design essenziale","Filiera responsabile","Recupero degli scarti nel ciclo produttivo"] // NB: niente 'idroponica' (errato per gli olivi)
};
const PRODUCTS={
  origine: {
    name:'Origine', price:22, intLabel:'Equilibrato', intensity:1, img:'Bottiglia.png', hover:'origine-hover.jpg', /* render ufficiale 9 set 2026 (da nuovebottiglie) */
    color:'#01656D', bg:'#EAF1F1', oil:'#01656D', world:'#EAF1F1', worldHover:'#DBE9E9', // Ottanio (brand)
    badge:'Per iniziare',
    certificazioni:'Agricoltura biologica',
    cultivar:'Ogliarola del Gargano · 100% BIO',
    profilo:{ fruttato:2, amaro:1, piccante:1 },
    note:['Mandorla','Erba fresca','Carciofo leggero'],
    desc:'Rotondo e dorato. Il rito di ogni giorno.',
    sottotitolo:"Il cuore pulsante della nostra terra. Un ritorno alle origini racchiuso in un gesto di purezza assoluta.",
    specifiche:"Un olio dal carattere fresco e rigenerante. Al naso sprigiona note di erba appena tagliata e sentori di mandorla verde. Al palato è armonioso, con un amaro e un piccante leggero e perfettamente bilanciato.",
    significato:"Il ritorno alla terra incontaminata. Origine è l'essenza prima, il punto di partenza dove la natura si esprime senza interferenze.",
    uso:"Piatti crudi, verdure, pesce, pane caldo. L'olio di tutti i giorni."
  },
  anima: {
    name:'Anima', price:22, intLabel:'Intenso', intensity:3, img:'Bottiglia2.png', hover:'anima-hover.jpg', /* render ufficiale 9 set 2026 */
    color:'#E7E12C', bg:'#F6F3D8', oil:'#E7E12C', world:'#F6F3D8', worldHover:'#ECE7C2', // Verde Acido (brand) — colore reale bottiglia: giallo=Anima
    badge:'Il più intenso',
    cultivar:'Monocultivar Coratina',
    profilo:{ fruttato:3, amaro:3, piccante:3 },
    note:['Carciofo','Foglia di pomodoro','Pepe'],
    desc:'Verde e fiero. Per chi vuole sentire l’oliva.',
    sottotitolo:"L'essenza più forte e profonda. Il carattere deciso di una sola varietà che non accetta compromessi.",
    specifiche:"Un'esplosione di intensità. Si distingue per il suo profumo spiccato dal gusto vibrante e persistente, con quella nota piccante finale che è il marchio di fabbrica della Coratina pura.",
    significato:"Rappresenta la parte più intima e persistente del nostro uliveto. Un monocultivar che non teme confronti. Un olio che vibra, che punge, che emoziona.",
    uso:"Carni, legumi, zuppe, bruschetta importante. A crudo, sempre."
  },
  alchimia: {
    name:'Alchimia', price:22, intLabel:'Medio', intensity:2, img:'Bottiglia3.png', hover:'alchimia-hover.jpg', /* render ufficiale 9 set 2026 */
    color:'#D75742', bg:'#F8E9E4', oil:'#D75742', world:'#F8E9E4', worldHover:'#F1D9D1', // Terracotta (brand) — colore reale bottiglia: rosso=Alchimia
    badge:null,
    cultivar:'Blend · Ogliarola, Coratina, Leccino',
    profilo:{ fruttato:2, amaro:2, piccante:2 },
    note:['Fruttato','Rotondo','Armonico'],
    desc:'L’equilibrio cercato. Tre cultivar, un rito.',
    sottotitolo:"L'arte della composizione. L'equilibrio perfetto nato dall'unione di varietà diverse.",
    specifiche:"Unisce la struttura dei frutti più decisi alla morbidezza di quelli più gentili. Il risultato è un olio rotondo, fluido e complesso, capace di adattarsi a ogni sfumatura del palato.",
    significato:"Un blend di olio extravergine nato dall'incontro segreto delle migliori varietà del nostro territorio.",
    uso:"Il jolly, dall'antipasto al secondo."
  }
};
/* prezzi: formattatore unico. Oggi i prezzi sono interi, ma sono placeholder (~22-25 € da
   confermare): al primo decimale '€'+n avrebbe stampato "€67.5" col punto anglosassone. */
const EUR=new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
const eur=n=>EUR.format(n).replace(/\s/g,' ');
/* carrello persistente: il footer ha link a pagine Shopify vere (/pages/spedizioni ecc.),
   quindi bastava un click da "quanto costa la spedizione?" per perdere tutto. */
/* MAX_QTY: guardia operativa, non un claim pubblicato — senza, "+" tenuto premuto su mobile
   arrivava a decine di bottiglie di vetro. TODO: quante ne entra davvero in una scatola? */
const MAX_QTY=12;
const MIN_PRICE=Math.min(...Object.values(PRODUCTS).map(p=>p.price));
/* prezzo del set gia' pubblicato in olio-home.liquid («€59 invece di €66 presi singolarmente»:
   i €66 sono le tre bottiglie singole sommate, mai un prezzo praticato prima).
   Prodotto Shopify reale: "il-rituale-completo" (al checkout sostituisce i 3 oli singoli).
   Questa costante è solo per il display del carrello: va tenuta allineata a mano al prezzo reale su Shopify. */
const SET_PRICE=59;
const CART_KEY='ov_cart';
const cart=(()=>{ try{
  const s=JSON.parse(localStorage.getItem(CART_KEY))||{};
  /* il carrello arriva da localStorage: puo' essere vecchio o manomesso. Va normalizzato QUI,
     non solo nei +/- del drawer, altrimenti un ov_cart con 40 bottiglie o 2.5 entra intatto. */
  return Object.fromEntries(Object.entries(s)
    .filter(([k,v])=>PRODUCTS[k]&&typeof v==='number'&&isFinite(v)&&v>0)
    .map(([k,v])=>[k,Math.min(MAX_QTY,Math.max(1,Math.floor(v)))]));
}catch(e){ return {}; } })();
function saveCart(){ try{ localStorage.setItem(CART_KEY,JSON.stringify(cart)); }catch(e){} }
let currentProduct='venere', qSel=1;
/* PRICE_MULT rimosso: stampava sul bottone un prezzo scontato (3 bottiglie -> €59) che addToCart
   non applicava mai, e il carrello poi segnava €66. Il prezzo mostrato dev'essere quello addebitato.
   Lo sconto vero esiste solo sul set dei TRE oli diversi, ed e' gestito dal prodotto-bundle. */

/* hand-drawn olive characters */
/* Oliva line-art aulica: corpo + stelo + foglia con nervatura + accenno di riflesso.
   Niente faccia/braccia (scelta del cliente: registro premium, non cartoon). Il parametro
   variant è mantenuto per compatibilità con i punti di chiamata, ma non cambia il disegno. */
function olive(variant){
  return `<svg viewBox="0 0 100 124" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:100%;height:auto;display:block">
    <path d="M50,30 C33,30 25,50 26,72 C27,95 40,106 50,106 C60,106 73,95 74,72 C75,50 67,30 50,30 Z"/>
    <path d="M50,30 C51,22 53,17 57,13"/>
    <path d="M57,13 C64,5 79,6 85,16 C78,23 64,22 57,13 Z"/>
    <path d="M60,15 C68,15 77,17 83,18"/>
    <path d="M41,48 C37,58 37,70 40,82"/>
  </svg>`;
}
document.querySelectorAll('.ochar').forEach(el=>{ el.innerHTML=olive(el.getAttribute('data-char')||'happy'); });
document.querySelectorAll('.storybot').forEach(el=>{ el.innerHTML=bottle('#3a5a2c'); });

/* ---- Il mito: scena pinnata — la copy si dissolve da un beat all'altro allo scroll, sul video morph ---- */
(function(){
  var myth=document.getElementById('myth'); if(!myth) return;
  var beats=[].slice.call(myth.querySelectorAll('.myth__beat'));
  if(!beats.length) return;
  var cur=-1;
  function setActive(i){ if(i===cur) return; cur=i; beats.forEach(function(b,idx){ b.classList.toggle('on', idx===i); }); }
  var ticking=false;
  function onScroll(){
    if(ticking) return; ticking=true;
    requestAnimationFrame(function(){
      var vh=window.innerHeight;
      var total=myth.offsetHeight - vh;
      var scrolled=Math.min(Math.max(-myth.getBoundingClientRect().top,0), total);
      var pr= total>0 ? scrolled/total : 0;
      var i=Math.min(beats.length-1, Math.floor(pr*beats.length + 0.0001));
      setActive(i<0?0:i);
      ticking=false;
    });
  }
  setActive(0);
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();
})();

/* bottiglia line-art aulica (era una bottiglia-cartoon con scritta "olìo"): coerente col registro premium.
   Il parametro color è mantenuto per compatibilità ma il disegno usa currentColor. */
function bottle(color){return `<svg class="bot" viewBox="0 0 120 230" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:100%;height:auto;display:block"><path d="M52 8 h16 v13 h-16 Z"/><path d="M54 21 C54 35 40 40 40 58 L40 200 C40 214 48 222 60 222 C72 222 80 214 80 200 L80 58 C80 40 66 35 66 21"/><path d="M40 120 L80 120"/><path d="M40 168 L80 168"/></svg>`;}
/* (render [data-bottle] rimosso con la sezione "I numeri") */



/* grid */
function dropMeter(level){let s='';for(let i=1;i<=3;i++){const on=i<=level?' on':'';s+=`<svg class="drp${on}" viewBox="0 0 16 20" aria-hidden="true"><path d="M8 1.5C8 1.5 2.5 9 2.5 13a5.5 5.5 0 0 0 11 0C13.5 9 8 1.5 8 1.5Z"/></svg>`;}return s;}

/* asset bottiglie/logo — render ufficiali dal 9 set 2026. Su Shopify le URL arrivano da window.OLIO_ASSETS (asset_url); in locale fallback su image/ */
function olioAsset(file){
  if(!file) return '';
  /* una URL assoluta o radicata (es. CDN Shopify) e' gia' risolta: passa cosi' com'e', non e' un nome di file da cercare in OLIO_ASSETS */
  if(/^(https?:)?\/\//.test(file) || file.charAt(0)==='/') return file;
  return (window.OLIO_ASSETS && window.OLIO_ASSETS[file]) ? window.OLIO_ASSETS[file] : ('image/'+file);
}
function bottleImg(p, cls, lazy){ const l=(lazy===false)?'':' loading="lazy"'; return `<img class="${cls}" src="${olioAsset(p.img)}" alt="Olio Venere ${p.name}"${l} decoding="async">`; }
const REDUCE_MOTION=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
/* .page{display:none} non impedisce il download: prima ogni [data-asset] veniva risolto subito,
   quindi la home scaricava about-hero.jpg (580 KB) e about-gesto.mp4 (932 KB) di pagine mai aperte.
   In piu' i video partivano ignorando prefers-reduced-motion, che il CSS rispetta ovunque. */
function olioResolve(el){
  if(el.dataset.olioDone) return;
  const pg = el.closest('.page');
  if(pg && !pg.classList.contains('active')) return;
  el.dataset.olioDone='1';
  if(el.dataset.poster) el.poster=olioAsset(el.dataset.poster); /* anteprima leggera subito, mentre il video (piu' pesante) bufferizza */
  el.src = olioAsset(el.getAttribute('data-asset'));
  if(el.tagName==='VIDEO'){
    if(REDUCE_MOTION){ el.removeAttribute('autoplay'); el.removeAttribute('loop'); el.setAttribute('controls',''); try{el.pause();}catch(e){} return; }
    try{ el.load(); var p=el.play(); if(p&&p.catch) p.catch(function(){}); }catch(e){}
  }
}
function olioResolveAll(){ document.querySelectorAll('[data-asset]').forEach(olioResolve); }
olioResolveAll();

/* ---- scheda prodotto: render CONDIVISO da popup E pagina prodotto (fonte unica PRODUCTS + LINEA) ---- */
const PROFILO_LAB={fruttato:'Fruttato',amaro:'Amaro',piccante:'Piccante'};
function profileRows(pr){ return Object.keys(PROFILO_LAB).map(k=>`<div class="im__prow"><span>${PROFILO_LAB[k]}</span><span class="im__drops">${dropMeter(pr[k])}</span></div>`).join(''); }
function infoSectionsHTML(p){
  return `
    <div class="im__sec"><h3 class="im__h">Specifiche</h3><p class="im__txt">${p.specifiche}</p></div>
    <div class="im__sec"><h3 class="im__h">Significato</h3><p class="im__txt">${p.significato}</p></div>
    <div class="im__sec"><h3 class="im__h">Profilo</h3>${profileRows(p.profilo)}</div>
    <div class="im__sec"><h3 class="im__h">Note</h3><div class="im__chips">${p.note.map(n=>`<span class="im__chip">${n}</span>`).join('')}</div></div>
    <div class="im__sec"><h3 class="im__h">In cucina</h3><p class="im__txt">${p.uso}</p></div>
    <div class="im__sec"><h3 class="im__h">All’assaggio</h3><p class="im__txt">${LINEA.assaggio}</p></div>
    <div class="im__sec"><h3 class="im__h">Origine &amp; processo</h3><p class="im__origin">${LINEA.origine}</p><ul class="im__list">${LINEA.processo.map(s=>`<li>${s}</li>`).join('')}</ul></div>
    ${p.certificazioni?`<div class="im__sec"><h3 class="im__h">Certificazioni</h3><div class="im__chips"><span class="im__chip">${p.certificazioni}</span></div></div>`:''}`;
}

/* ---- popup info prodotto: X / click-fuori / ESC, scroll-lock, focus trap ---- */
(function(){
  const ov=document.getElementById('infoOv'), modal=document.getElementById('infoModal'), body=document.getElementById('infoBody'), closeBtn=document.getElementById('infoClose');
  if(!ov||!modal||!body||!closeBtn) return;
  let lastFocus=null;
  function build(id){
    const p=PRODUCTS[id]; if(!p) return '';
    return `
      <h2 class="visually-hidden" id="imName">${p.name}</h2>
      <div class="im__essentials">
        <div class="im__minisec">
          <h3 class="im__h">Specifiche</h3>
          <p class="im__txt">${p.specifiche}</p>
        </div>
        <div class="im__minisec">
          <h3 class="im__h">Significato</h3>
          <p class="im__txt im__txt--meaning">${p.significato}</p>
        </div>
      </div>`;
  }
  function trap(e){
    if(e.key==='Escape'){ closeInfo(); return; }
    if(e.key!=='Tab') return;
    const f=[...modal.querySelectorAll('button,[href],input,[tabindex]:not([tabindex="-1"])')].filter(el=>el.offsetParent!==null);
    if(!f.length) return;
    const first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
  function closeInfo(){
    ov.classList.remove('open'); modal.classList.remove('open'); modal.setAttribute('aria-hidden','true');
    document.body.style.overflow=''; document.removeEventListener('keydown',trap);
    if(lastFocus&&lastFocus.focus) lastFocus.focus();
  }
  window.closeInfo=closeInfo;
  window.openInfo=function(id){
    body.innerHTML=build(id); body.scrollTop=0;
    const p=PRODUCTS[id]; if(p){ modal.style.setProperty('--modal-tint', p.world); modal.style.setProperty('--modal-accent', p.color); } /* velo + trattini sotto i titoli nel colore del prodotto attivo */
    lastFocus=document.activeElement;
    ov.classList.add('open'); modal.classList.add('open'); modal.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden'; document.addEventListener('keydown',trap);
    setTimeout(()=>closeBtn.focus(),60);
  };
  ov.addEventListener('click',closeInfo);
  closeBtn.addEventListener('click',closeInfo);
})();

function renderScale(scale) {
  return Object.entries(scale).map(([key, val]) => {
    let dots = '';
    for (let i = 1; i <= 3; i++) {
      dots += `<span class="dot-scale${i <= val ? ' fill' : ''}"></span>`;
    }
    return `<div class="scale-row"><span class="scale-label">${key.charAt(0).toUpperCase() + key.slice(1)}</span><span class="scale-dots">${dots}</span></div>`;
  }).join('');
}

function renderNotes(notes) {
  return notes.map(n => `<span class="note-chip">${n}</span>`).join('');
}

const grid=document.getElementById('grid');
Object.entries(PRODUCTS).forEach(([id,p], index)=>{
  const c=document.createElement('div');
  c.className='card reveal';
  c.setAttribute('data-open', id);
  c.style.setProperty('--bg-color', p.world);
  c.style.setProperty('--bg-hover', p.worldHover);
  c.style.transitionDelay = `${index * 90}ms`;
  
  const badgeHtml = p.badge ? `<span class="card__badge">${p.badge}</span>` : '';
  const essenceHtml = p.essence ? `<div class="card__essence">${p.essence}</div>` : '';
  
  c.innerHTML = `
    ${badgeHtml}
    <div class="card__img" style="background:${p.world}">
      ${bottleImg(p,'cbottle')}
      <img class="cbottle--hover" src="${olioAsset(p.hover)}" alt="" aria-hidden="true" loading="lazy" decoding="async">
    </div>
    <div class="card__top">
      <div><h3>${p.name}</h3></div>
      <span class="card__int" title="Intensità: ${p.intLabel}">${dropMeter(p.intensity)}</span>
    </div>
    <div class="card__lab">${p.intLabel}</div>
    <p class="card__note">${p.desc}</p>
    <div class="card__buy">
      <div class="card__price-wrap">
        <span class="price">500 ml · €${p.price}</span>
      </div>
      <div class="card__actions">
        <button class="btn btn--green add" data-add="${id}">Aggiungi</button>
        <button class="btn btn--out" data-info="${id}"><svg class="btn__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v5"/><path d="M12 7.5h.01"/></svg>Scopri di più</button>
      </div>
    </div>
  `;
  grid.appendChild(c);
});

/* 4ª card SET "Il Rituale completo" nello Shop — la CTA riusa la logica bundle (#shopBundleAdd, vedi più sotto) */
(function(){
  if(!grid) return;
  const trioIds=['origine','anima','alchimia'];
  const was=trioIds.reduce((s,id)=>s+PRODUCTS[id].price,0); // 66 oggi (3 × €22)
  /* il confronto dichiara la sua base ("presi singolarmente"): €66 non e' un prezzo praticato
     prima — lo store non ha storico — ma la somma delle tre bottiglie singole. Un barrato nudo
     lascerebbe intendere un ribasso mai avvenuto. Stessa formula di olio-home.liquid. */
  const setCard=document.createElement('div');
  setCard.className='card card--set reveal';
  setCard.style.transitionDelay=`${Object.keys(PRODUCTS).length*90}ms`;
  setCard.innerHTML=`
    <span class="card__badge card__badge--set">Set</span>
    <div class="card__img card__img--trio">
      ${trioIds.map(id=>`<img src="${olioAsset(PRODUCTS[id].img)}" alt="Olio Venere ${PRODUCTS[id].name}" loading="lazy" decoding="async">`).join('')}
    </div>
    <div class="card__top"><div><h3>Il Rituale completo</h3></div></div>
    <div class="card__lab card__lab--set">Origine · Anima · Alchimia</div>
    <p class="card__note">I tre oli della linea, un unico rito quotidiano.</p>
    <div class="card__buy">
      <div class="card__price-wrap">
        <span class="price price--set">€59 <span class="price__was">invece di €${was} presi singolarmente</span></span>
      </div>
      <div class="card__actions">
        <button class="btn btn--green add" id="shopBundleAdd" type="button">Aggiungi il rito</button>
      </div>
    </div>`;
  grid.appendChild(setCard);
})();

/* ritual carousel (home) — crossfade + scale, swipe + pallini + frecce, avanza da solo: il tempo di
   permanenza di ogni scheda si calcola dalla lunghezza del sottotitolo (tempo di lettura), non e' fisso. */
(function(){
  const track=document.getElementById('caroTrack');
  const viewport=document.getElementById('caroViewport');
  const dotsWrap=document.getElementById('caroDots');
  if(!track||!viewport||!dotsWrap) return;
  const ritualSec=document.getElementById('ritual');
  const REDUCE_CARO=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function readTimeMs(text){
    const words=(text||'').trim().split(/\s+/).filter(Boolean).length;
    const ms=Math.round(words/200*60000)+2200; /* 200 parole/min, ritmo comodo; +2,2s per nome/eyebrow/prezzo e per il crossfade */
    return Math.max(4500,Math.min(9000,ms));
  }
  const ids=Object.keys(PRODUCTS);
  track.innerHTML=ids.map((id,i)=>{const p=PRODUCTS[id];return `
    <div class="slide${i===0?' is-active':''}" data-id="${id}" style="--slide-accent:${p.color}">
      <div class="slide__media"><button type="button" class="slide__bottle" data-open="${id}" aria-label="Vai alla scheda di ${p.name}"><img class="pbottle" src="${olioAsset(p.img)}" alt="Olio Venere ${p.name}" decoding="async"><img class="pbottle pbottle--scene" src="${olioAsset(p.hover)}" alt="" aria-hidden="true" loading="lazy" decoding="async"></button></div>
      <div class="slide__body">
        <h3 class="slide__name">${p.name}</h3>
        <div class="slide__meta">
          <span class="slide__int" title="Intensità: ${p.intLabel}">${dropMeter(p.intensity)} ${p.intLabel}</span>
          <button type="button" class="slide__info" data-info="${id}" aria-label="Info prodotto" title="Info prodotto"><svg class="btn__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v5"/><path d="M12 7.5h.01"/></svg></button>
        </div>
        <p class="slide__desc">${p.sottotitolo}</p>
        <span class="slide__price">500 ml · €${p.price}</span>
        <div class="slide__cta">
          <button class="btn btn--green add" data-add="${id}">Aggiungi al carrello</button>
        </div>
      </div>
    </div>`;}).join('');
  dotsWrap.innerHTML=ids.map((id,i)=>`<button type="button" class="caro__dot${i===0?' on':''}" data-i="${i}" role="tab" aria-label="${PRODUCTS[id].name}" aria-selected="${i===0}"></button>`).join('');
  const slides=[...track.children];
  const dots=[...dotsWrap.children];
  const n=ids.length; let idx=0;
  const caroBg=document.querySelector('.caro__bg');
  const ritualEl=document.getElementById('ritual');
  function relLum(hex){const c=hex.replace('#',''),f=v=>{v/=255;return v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4);};return .2126*f(parseInt(c.slice(0,2),16))+.7152*f(parseInt(c.slice(2,4),16))+.0722*f(parseInt(c.slice(4,6),16));}
  function render(){ slides.forEach((s,i)=>{const on=i===idx; s.classList.toggle('is-active',on); s.toggleAttribute('inert',!on);}); /* opacity:0 non toglie dal tab order: erano 6 tap stop su prodotti invisibili */ dots.forEach((d,i)=>{d.classList.toggle('on',i===idx); d.setAttribute('aria-selected', i===idx);}); const p=PRODUCTS[ids[idx]]; document.documentElement.style.setProperty('--caro-deep', p.color); /* colore identico al codice fornito: niente piu' scurimento, che sul giallo virava a verde oliva */ viewport.style.setProperty('--caro-accent', p.color); if(ritualEl) ritualEl.classList.toggle('ritual--onlight', relLum(p.color)>.4); /* sul giallo il testo chiaro spariva (contrasto ~1.4:1): sotto una certa luminanza del fondo il testo passa a scuro */ }
  let autoTimer=null, inView=false, paused=false;
  function stopAuto(){ if(autoTimer){ clearTimeout(autoTimer); autoTimer=null; } }
  function scheduleAuto(){
    stopAuto();
    if(!inView||paused||REDUCE_CARO) return;
    autoTimer=setTimeout(()=>{ goTo(idx+1); }, readTimeMs(PRODUCTS[ids[idx]].sottotitolo));
  }
  function syncAuto(){ if(inView&&!paused&&!REDUCE_CARO) scheduleAuto(); else stopAuto(); }
  function goTo(i){ idx=(i+n)%n; render(); scheduleAuto(); }
  const prev=document.getElementById('caroPrev'), next=document.getElementById('caroNext');
  if(prev) prev.onclick=()=>goTo(idx-1);
  if(next) next.onclick=()=>goTo(idx+1);
  dotsWrap.addEventListener('click',e=>{const d=e.target.closest('[data-i]'); if(d) goTo(+d.getAttribute('data-i'));});
  /* swipe (crossfade: avanza/indietro, nessun trascinamento live) */
  let sx=0,sy=0,sw=false,moved=false;
  viewport.addEventListener('pointerdown',e=>{sw=true;moved=false;sx=e.clientX;sy=e.clientY;});
  window.addEventListener('pointermove',e=>{ if(sw && Math.abs(e.clientX-sx)>8) moved=true; });
  window.addEventListener('pointerup',e=>{ if(!sw)return; sw=false; const dx=e.clientX-sx, dy=e.clientY-sy; if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) goTo(idx + (dx<0?1:-1)); });
  /* dopo uno swipe non far scattare il click sui bottoni interni */
  viewport.addEventListener('click',e=>{ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);
  render();
  if(ritualSec){
    ritualSec.addEventListener('mouseenter',()=>{paused=true;syncAuto();});
    ritualSec.addEventListener('mouseleave',()=>{paused=false;syncAuto();});
    ritualSec.addEventListener('focusin',()=>{paused=true;syncAuto();});
    ritualSec.addEventListener('focusout',()=>{paused=false;syncAuto();});
    new IntersectionObserver(es=>{es.forEach(e=>{inView=e.isIntersecting; syncAuto();});},{threshold:.4}).observe(ritualSec);
  }
  document.addEventListener('visibilitychange',()=>{ if(document.hidden) stopAuto(); else syncAuto(); });
})();

/* mito (home) — avanza da solo come il carosello degli oli, invece di 3 schermate intere da scrollare */
(function(){
  const wrap=document.getElementById('mitoRows'), dotsWrap=document.getElementById('mitoDots');
  if(!wrap||!dotsWrap) return;
  const rows=[...wrap.children];
  const n=rows.length; if(n<2) return;
  dotsWrap.innerHTML=rows.map((_,i)=>`<button type="button" class="mito__dot${i===0?' on':''}" data-i="${i}" role="tab" aria-label="Tappa ${i+1} di ${n}" aria-selected="${i===0}"></button>`).join('');
  const dots=[...dotsWrap.children];
  const REDUCE=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  const mitoSec=document.getElementById('mito');
  let idx=0, timer=null, inView=false, paused=false;
  function render(){ rows.forEach((r,i)=>{const on=i===idx; r.classList.toggle('is-active',on); r.toggleAttribute('inert',!on);}); dots.forEach((d,i)=>{const on=i===idx; d.classList.toggle('on',on); d.setAttribute('aria-selected',on);}); }
  function goTo(i){ idx=(i+n)%n; render(); }
  function next(){ goTo(idx+1); }
  function start(){ if(timer) return; timer=setInterval(next,5500); }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } }
  function sync(){ if(inView && !paused && !REDUCE && !document.hidden) start(); else stop(); }
  dotsWrap.addEventListener('click',e=>{ const d=e.target.closest('[data-i]'); if(!d) return; goTo(+d.getAttribute('data-i')); stop(); sync(); });
  if(mitoSec){
    mitoSec.addEventListener('mouseenter',()=>{paused=true;sync();});
    mitoSec.addEventListener('mouseleave',()=>{paused=false;sync();});
    mitoSec.addEventListener('focusin',()=>{paused=true;sync();});
    mitoSec.addEventListener('focusout',()=>{paused=false;sync();});
    new IntersectionObserver(es=>{es.forEach(e=>{inView=e.isIntersecting; sync();});},{threshold:.4}).observe(mitoSec);
  }
  document.addEventListener('visibilitychange',sync);
})();

/* nav */
let curPage='home';
const hdEl=document.querySelector('.hd');
/* header trasparente sopra un hero a tutta pagina, pieno appena lo si supera.
   Prima la condizione era cablata su curPage==='home', quindi Chi siamo (che ha il suo
   hero .abh) nasceva col fondo bianco sopra la foto. Ora dipende dal FATTO che la pagina
   abbia un hero in cima, cosi vale anche per le pagine che verranno. */
function pageHero(){
  const p=document.getElementById(curPage); if(!p) return null;
  const h=p.querySelector('.hero, .abh');
  return (h && h.offsetTop < 200) ? h : null;   /* dev'essere in cima: su Chi siamo l'hero parte a 64px (indice laterale + barra progresso) */
}
function updateHeader(){ const h=pageHero(); /* pieno quando l'hero e' quasi uscito dalla finestra: piu' affidabile di un confronto con innerHeight */
  const solid = h ? (h.getBoundingClientRect().bottom < window.innerHeight*0.3) : true;
  if(hdEl) hdEl.classList.toggle('solid',solid); }
window.addEventListener('scroll',updateHeader,{passive:true});
updateHeader();

/* header a scomparsa: si ritrae scrollando in giu', riappare scrollando in su (come molti siti).
   scrollY resta veritiero anche con lo smooth scroll -> direzione affidabile. Non si nasconde
   vicino alla cima, ne' con menu mobile / menu account / modale aperti. */
(function(){
  if(!hdEl) return;
  var last = window.scrollY<0?0:window.scrollY, ticking=false;
  function anyMenuOpen(){
    var mn=document.getElementById('menu'), am=document.getElementById('acctMenu');
    return (mn && mn.classList.contains('open')) || (am && am.classList.contains('open'))
      || document.body.style.overflow==='hidden'
      || document.documentElement.classList.contains('intro-lock');
  }
  function upd(){
    ticking=false;
    var y=window.scrollY; if(y<0) y=0;
    if(Math.abs(y-last)<5){ last=y; return; }
    if(anyMenuOpen() || y<=120 || y<last) hdEl.classList.remove('hd--hidden');
    else hdEl.classList.add('hd--hidden');
    last=y;
  }
  window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } },{passive:true});
})();

/* lo stato attivo viveva solo dentro go(), che al primo caricamento non viene mai chiamato:
   all'atterraggio nessuna voce risultava attiva. Ora e' una funzione, invocata anche al boot.
   Aggiunge aria-current: prima lo stato era solo visivo (sottolineatura), muto per screen reader. */
function syncNav(page){
  /* il menu mobile e' uscito da .hd: senza il secondo selettore nessuna voce
     del pannello si accendeva piu'. */
  document.querySelectorAll('.hd [data-nav], .mnav [data-nav]').forEach(a=>{
    const on = a.getAttribute('data-nav')===page;
    a.classList.toggle('cur',on);
    if(on) a.setAttribute('aria-current','page'); else a.removeAttribute('aria-current');
  });
}
const PAGE_TITLES={home:"Olio Venere — extravergine biologico del Gargano",shop:"La linea The Ritual — Olio Venere",product:"Scheda prodotto — Olio Venere",about:"Chi siamo — Olio Venere",blog:"Il diario — Olio Venere",article:"Articolo — Olio Venere",contact:"Contatti — Olio Venere"};
/* URL veri per pagina: product/article sono dinamiche (dipendono da quale scheda/articolo e' aperto),
   go() riceve il loro URL esplicito da chi le apre (openProduct/openArticle). Le altre sono fisse. */
const PAGE_URLS={home:'/',shop:'/pages/collezione',about:'/pages/chi-siamo',blog:'/blogs/diario',contact:'/pages/contact'};
let suppressPush=false; /* true durante un popstate: l'URL e' gia' cambiato dal browser, non va spinto di nuovo */
/* la SPA cambiava pagina senza spostare il fuoco, senza cambiare document.title e senza annunciare
   nulla: da tastiera il fuoco finiva su <body>, con uno screen reader non succedeva niente. */
function go(page,url){
  // Nascondi tutte le pagine
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active','page--in'));
  // Mostra la nuova con fade-in
  const el=document.getElementById(page);
  if(el){
    el.classList.add('active');
    // Triggera il reflow per far partire l'animazione CSS
    void el.offsetWidth;
    el.classList.add('page--in');
    setTimeout(function(){ el.classList.remove('page--in'); }, 450); /* toglie il transform residuo -> niente stacking-context che scavalca lo sfondo a bolle (.olio-mb) */
  }
  syncNav(page);
  window.scrollTo({top:0,behavior:'instant'}); refreshObserve();
  if(el){ el.setAttribute('tabindex','-1'); el.focus({preventScroll:true}); }
  if(PAGE_TITLES[page]) document.title=PAGE_TITLES[page];
  const _rl=document.getElementById('routeLive');
  if(_rl) _rl.textContent=(PAGE_TITLES[page]||page)+' — pagina caricata';
  curPage=page; updateHeader();
  if(!suppressPush){
    const target=url||PAGE_URLS[page];
    if(target && location.pathname!==target) history.pushState({page:page,url:target},'',target);
  }
  if(typeof olioResolveAll==='function') olioResolveAll(); /* risolve gli asset della pagina che si apre */
}
document.body.addEventListener('click',e=>{
  const nav=e.target.closest('[data-go]');
  if(nav){
    const page=nav.getAttribute('data-go');
    const h=nav.getAttribute('href');
    go(page);
    if(h&&h.startsWith('#')&&h.length>1){
      setTimeout(()=>{
        const t=document.querySelector(h);
        if(t)t.scrollIntoView({behavior:'smooth'});
      },80);
    }
    e.preventDefault();
    return;
  }
  const ad=e.target.closest('[data-add]');
  if(ad){
    if(ad.closest('#infoModal') && window.closeInfo) window.closeInfo(); /* prima: closeInfo azzera body.overflow e mangerebbe lo scroll-lock del drawer */
    addToCart(ad.getAttribute('data-add'),1,ad);
    return;
  }
  const inf=e.target.closest('[data-info]');
  if(inf){
    if(window.openInfo) window.openInfo(inf.getAttribute('data-info'));
    return;
  }
  const op=e.target.closest('[data-open]');
  if(op){
    openProduct(op.getAttribute('data-open'));
    return;
  }
});

/* product */
function openProduct(id){currentProduct=id;qSel=1;
  document.querySelectorAll('#qties .qopt').forEach(o=>{const on=o.getAttribute('data-q')==='1'; o.classList.toggle('sel',on); o.setAttribute('aria-pressed',on?'true':'false');});
  const p=PRODUCTS[id];
  document.getElementById('ppTitle').textContent=p.name;
  document.getElementById('ppCultivar').textContent=p.cultivar;
  document.getElementById('ppDesc').textContent=p.sottotitolo;
  document.getElementById('ppImg').style.background=p.bg;
  document.getElementById('ppBottle').innerHTML=bottleImg(p,'ppbottle');
  document.getElementById('ppDetails').innerHTML=infoSectionsHTML(p);
  updatePPPrice(); go('product','/products/'+id);
}
function updatePPPrice(){const p=PRODUCTS[currentProduct];document.getElementById('ppPrice').textContent=eur(p.price*qSel);}
document.getElementById('qties').addEventListener('click',e=>{const o=e.target.closest('.qopt');if(!o)return;qSel=+o.getAttribute('data-q');document.querySelectorAll('#qties .qopt').forEach(x=>{const on=x===o; x.classList.toggle('sel',on); x.setAttribute('aria-pressed',on?'true':'false');});updatePPPrice();});
document.getElementById('ppAdd').onclick=e=>addToCart(currentProduct,qSel,e.currentTarget);

/* ===== BLOG: fonte unica ARTICLES + lista + articolo (TOC, JSON-LD, condivisione) ===== */
const ARTICLES = {
  'olio-pizzica-in-gola': {
    slug:'olio-pizzica-in-gola',
    cat:"Capire l'olio",
    title:"Perché l'olio extravergine buono pizzica in gola",
    subtitle:"Quel pizzicore non è un difetto: è il segno di un olio vivo, appena franto.",
    excerpt:"Quel pizzicore in fondo alla gola non è un difetto: è il segno di un olio vivo, appena franto. Ecco cosa significa davvero.",
    date:"2026-05-22", dateLabel:"22 maggio 2026", read:"4 min",
    imgAlt:"Filo di olio extravergine versato a crudo su un cucchiaio", img:"blog-pizzica.jpg",
    metaTitle:"Perché l'olio extravergine buono pizzica in gola · Olio Venere",
    metaDesc:"Amaro e piccante non sono difetti: sono il segno dei polifenoli e di un extravergine fresco. Ecco perché un buon olio pizzica in gola.", // TODO Shopify SEO
    body:`<p>Versi un filo d'olio extravergine appena franto su una fetta di pane caldo, assaggi, e dopo un istante senti un pizzicore deciso in fondo alla gola, a volte tanto da farti tossire. La reazione istintiva è pensare a un difetto. È esattamente il contrario.</p>
<h2>Quel pizzicore è un buon segno</h2>
<p>Nei panel di assaggio professionali l'amaro e il piccante non vengono tollerati: vengono <em>cercati</em>. Sono due dei pregi che definiscono un olio extravergine di qualità, segno di olive sane, raccolte al punto giusto e lavorate in fretta. Un olio che pizzica è un olio vivo.</p>
<p>L'amaro si percepisce sulla lingua, il piccante arriva dopo, in gola. Più sono netti, purché equilibrati, più l'olio è giovane e ben fatto.</p>
<h2>Da dove arriva: i polifenoli</h2>
<p>Quel pizzicore è legato ai <strong>polifenoli</strong>, una famiglia di composti naturalmente presenti nell'oliva. Sono gli stessi antiossidanti che proteggono il frutto sulla pianta, e che ritroviamo nell'olio quando la lavorazione è delicata e veloce.</p>
<p>La regola è semplice: più l'olio è fresco e di qualità, più polifenoli conserva e più lo senti in gola. Con il tempo questi composti diminuiscono, e con loro il piccante.</p>
<blockquote class="art__pq">Il pizzicore non è un eccesso da correggere: è l'oliva che parla ancora.</blockquote>
<h2>Perché negli oli da supermercato spesso non lo senti</h2>
<p>Molti oli industriali partono da olive vecchie o stoccate troppo a lungo, vengono miscelati tra origini diverse o lavorati con il calore. Ogni passaggio in più allontana l'olio dal frutto e abbassa i polifenoli: il risultato è un olio piatto, che non disturba ma non racconta niente.</p>
<p>Un extravergine fresco, molito poche ore dopo la raccolta, fa il contrario: tiene tutto.</p>
<h3>Come riconoscerlo a casa</h3>
<ul>
<li><strong>Assaggialo a crudo</strong>, a piccoli sorsi e senza pane: lascia che arrivi in gola.</li>
<li><strong>Annusa</strong>: deve sapere di erba, carciofo, pomodoro verde, mai di rancido o di fritto.</li>
<li><strong>Aspetta</strong>: un amaro pulito e un piccante che resta qualche secondo sono buoni segni.</li>
</ul>
<h2>Negli oli Venere</h2>
<p>Nella nostra <a href="#" data-go="shop">linea The Ritual</a> il piccante lo trovi soprattutto in <a href="#" data-open="anima">Anima</a>, monocultivar di Coratina: la più intensa, verde e ricca di polifenoli. <a href="#" data-open="origine">Origine</a>, da Ogliarola del Gargano, è più rotonda ma resta viva. In entrambi i casi la differenza la fanno la raccolta a mano e la molitura entro dodici ore, il modo in cui <a href="#" data-go="about">lavoriamo da sempre</a>.</p>
<p>La prossima volta che un olio ti pizzica in gola, sorridi: stai assaggiando qualcosa di vero.</p>`,
    ctaHTML:`<h2>Senti la differenza</h2><p>Anima è la nostra più intensa: Coratina in purezza, viva di polifenoli.</p><a href="#" class="btn btn--green" data-open="anima">Assaggia Anima</a>`
  },
  'olio-del-gargano': {
    slug:'olio-del-gargano',
    cat:"Territorio",
    title:"Olio del Gargano: cosa rende speciale l'extravergine di questa terra",
    subtitle:"Tra il Monte Sant'Angelo e il mare, ulivi secolari e cultivar uniche danno un olio che racconta un luogo preciso.",
    excerpt:"Tra il Monte Sant'Angelo e il mare, ulivi secolari e cultivar uniche danno un olio che racconta una terra precisa. Ecco perché.",
    date:"2026-04-10", dateLabel:"10 aprile 2026", read:"5 min",
    imgAlt:"Oliveto del Gargano ai piedi del Monte Sant'Angelo", img:"blog-gargano.jpg",
    metaTitle:"Olio del Gargano: cosa lo rende speciale · Olio Venere",
    metaDesc:"Terroir, cultivar autoctone e filiera diretta: perché l'extravergine del Gargano, dalla Piana di Macchia, ha un carattere che non si importa.", // TODO Shopify SEO
    body:`<p>Olio del Gargano non è solo un'indicazione sulla mappa. È un insieme preciso di terra, clima e cultivar che, messi insieme, danno un extravergine che non si potrebbe fare altrove. Ecco cosa c'è dietro.</p>
<h2>Dove siamo: il Gargano, tra pietra e mare</h2>
<p>Il nostro oliveto è in <strong>Piana di Macchia</strong>, ai piedi del <strong>Monte Sant'Angelo</strong>, nel cuore del Gargano. Qui la montagna incontra l'Adriatico: pietra calcarea, sole pieno e una brezza salmastra che sale dal mare. È un microclima che mette gli ulivi alla prova e li ripaga in carattere.</p>
<h2>Le cultivar del territorio</h2>
<p>Tre varietà raccontano questa terra. L'<strong>Ogliarola del Gargano</strong> dà un olio rotondo e dolce, di grande finezza. La <strong>Coratina</strong> è il suo opposto: intensa, amara, ricchissima di polifenoli. Il <strong>Leccino</strong> porta equilibrio e morbidezza.</p>
<p>Da sole o insieme, sono la tavolozza con cui nasce la <a href="#" data-go="shop">linea The Ritual</a>.</p>
<h2>Perché del Gargano non è solo geografia</h2>
<p>Quello che i francesi chiamano <em>terroir</em> qui è evidente: il terreno, la brezza salmastra, gli alberi spesso centenari e la raccolta a mano si depositano tutti nel bicchiere. Cambia la terra, cambia il gusto, anche con le stesse cultivar.</p>
<blockquote class="art__pq">Un olio che sa di dove nasce: questo è il Gargano in bottiglia.</blockquote>
<h3>Biologico, per scelta</h3>
<p>Coltiviamo in <strong>biologico certificato</strong>: niente chimica di sintesi, rispetto dei tempi della pianta e del suolo. Una scelta che protegge il territorio e si sente nel frutto.</p>
<h2>Dall'oliveto alla bottiglia, senza intermediari</h2>
<p>Le olive arrivano al frantoio <strong>entro dodici ore</strong> dalla raccolta e vengono molite a freddo. Niente passaggi inutili, nessun intermediario: ogni etichetta riporta campo e data. Se vuoi conoscere le persone dietro tutto questo, leggi <a href="#" data-go="about">la nostra storia</a>.</p>
<p>Assaggiare l'olio del Gargano è il modo più diretto per capire perché un luogo può fare la differenza.</p>`,
    ctaHTML:`<h2>Tre cultivar, un rito</h2><p>Origine, Anima e Alchimia: la linea The Ritual del Gargano.</p><a href="#" class="btn btn--green" data-go="shop">Scopri la linea The Ritual</a>`
  }
};
const ARTICLES_ORDER = ['olio-pizzica-in-gola','olio-del-gargano'];

(function(){
  const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  const WM = '<svg class="bph__wm" viewBox="0 0 120 80" aria-hidden="true"><path d="M14 70 C 46 56 74 48 110 16"/><path d="M52 50 C 44 43 44 31 52 25 C 60 31 60 43 52 50 Z"/><path d="M74 40 C 66 33 66 21 74 15 C 82 21 82 33 74 40 Z"/><circle cx="98" cy="22" r="6"/></svg>';
  const ph = (label,cover)=>`<div class="bph${cover?' bph--cover':''}" role="img" aria-label="${label}">${WM}<span class="bph__lab">${label}</span></div>`;
  const media = (a,cover)=> a.img ? `<img class="bph__photo" src="${olioAsset(a.img)}" alt="${a.imgAlt}" loading="lazy" decoding="async">` : ph(a.imgAlt,cover); /* foto reale se presente, placeholder altrimenti */
  const meta = (a)=>`${a.dateLabel} · ${a.read}`;
  const slugify = (s)=>('sec-'+s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''));
  const stripTags = (h)=>{ const d=document.createElement('div'); d.innerHTML=h; return (d.textContent||'').replace(/\s+/g,' ').trim(); };

  function cardHTML(slug){ const a=ARTICLES[slug]; return `<article class="bcard" data-article="${slug}" tabindex="0" role="link" aria-label="${a.title}">
      <div class="bcard__media"><span class="bcard__cat">${a.cat}</span>${media(a)}</div>
      <div class="bcard__body">
        <h2 class="bcard__h">${a.title}</h2>
        <p class="bcard__ex">${a.excerpt}</p>
        <p class="bcard__meta">${meta(a)}</p>
        <span class="bcard__more">Leggi <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>
      </div></article>`; }

  function renderBlogList(){
    const g=document.getElementById('blogGrid'); if(g) g.innerHTML=ARTICLES_ORDER.map(cardHTML).join('');
    const ld=document.getElementById('blogLd');
    if(ld){ ld.textContent=JSON.stringify({ "@context":"https://schema.org","@type":"Blog","name":"Il diario · Olio Venere","description":"Storie di terra, cultivar e gesti dietro ogni bottiglia.","blogPost":ARTICLES_ORDER.map(s=>{const a=ARTICLES[s];return {"@type":"BlogPosting","headline":a.title,"description":a.excerpt,"datePublished":a.date,"author":{"@type":"Organization","name":"Olio Venere"}};}) }); }
  }

  let tocIo=null;
  function initToc(){
    const links=[].slice.call(document.querySelectorAll('#artTocList a'));
    const heads=links.map(l=>document.getElementById(l.getAttribute('data-toc'))).filter(Boolean);
    links.forEach(l=>l.onclick=()=>{ const el=document.getElementById(l.getAttribute('data-toc')); if(el) el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'}); });
    if(tocIo) tocIo.disconnect();
    tocIo=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){ const id=e.target.id; links.forEach(l=>l.classList.toggle('on',l.getAttribute('data-toc')===id)); } }); },{rootMargin:'-18% 0px -72% 0px',threshold:0});
    heads.forEach(h=>tocIo.observe(h));
    if(links[0]) links[0].classList.add('on');
  }

  function injectLd(a){
    const url='/blogs/diario/'+a.slug;
    const ld=[
      { "@context":"https://schema.org","@type":"BlogPosting","headline":a.title,"description":a.excerpt,"articleBody":stripTags(a.body),"datePublished":a.date,"dateModified":a.date,"author":{"@type":"Organization","name":"Olio Venere"},"publisher":{"@type":"Organization","name":"Olio Venere"},"image":a.imgAlt,"articleSection":a.cat,"mainEntityOfPage":{"@type":"WebPage","@id":url} },
      { "@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[
        {"@type":"ListItem","position":1,"name":"Home","item":"/"},
        {"@type":"ListItem","position":2,"name":"Il diario","item":"/blogs/diario"},
        {"@type":"ListItem","position":3,"name":a.title}
      ] }
    ];
    document.getElementById('artLd').textContent=JSON.stringify(ld);
  }

  function setupShare(a){
    const url=(location.origin||'')+location.pathname+'#'+a.slug;
    const x=document.getElementById('artShareX'), wa=document.getElementById('artShareWa'), c=document.getElementById('artCopy');
    if(x) x.href='https://twitter.com/intent/tweet?text='+encodeURIComponent(a.title)+'&url='+encodeURIComponent(url);
    if(wa) wa.href='https://wa.me/?text='+encodeURIComponent(a.title+' '+url);
    if(c) c.onclick=()=>{ const done=()=>{ if(window.showToast) showToast('Link copiato'); }; try{ navigator.clipboard.writeText(url).then(done,done); }catch(e){ done(); } };
  }

  function openArticle(slug){
    const a=ARTICLES[slug]; if(!a) return;
    document.getElementById('artCat').textContent=a.cat;
    document.getElementById('artTitle').textContent=a.title;
    document.getElementById('artSub').textContent=a.subtitle;
    const t=document.getElementById('artTime'); t.textContent=a.dateLabel; t.setAttribute('datetime',a.date);
    document.getElementById('artRead').textContent=a.read;
    document.getElementById('artCover').innerHTML=media(a,true);
    const body=document.getElementById('artBody'); body.innerHTML=a.body;
    const h2s=[].slice.call(body.querySelectorAll('h2'));
    document.getElementById('artTocList').innerHTML=h2s.map(h=>{ const id=slugify(h.textContent); h.id=id; return `<li><a data-toc="${id}">${h.textContent}</a></li>`; }).join('');
    document.getElementById('artCta').innerHTML=a.ctaHTML;
    document.getElementById('artRelated').innerHTML=ARTICLES_ORDER.filter(s=>s!==slug).map(cardHTML).join('');
    injectLd(a); setupShare(a);
    const tc=document.getElementById('artToc'); if(tc) tc.classList.remove('open');
    go('article','/blogs/diario/'+slug); initToc();
  }
  window.openArticle=openArticle;

  const tocHead=document.getElementById('artTocHead');
  if(tocHead) tocHead.addEventListener('click',()=>{ if(window.matchMedia('(max-width:860px)').matches) document.getElementById('artToc').classList.toggle('open'); });

  document.body.addEventListener('click',e=>{ const el=e.target.closest('[data-article]'); if(el){ e.preventDefault(); openArticle(el.getAttribute('data-article')); } });
  document.body.addEventListener('keydown',e=>{ if((e.key==='Enter'||e.key===' ') && e.target && e.target.matches && e.target.matches('.bcard[data-article]')){ e.preventDefault(); openArticle(e.target.getAttribute('data-article')); } });

  renderBlogList();
})();

/* tabs prodotto rimosse: la scheda ora è generata da PRODUCTS in #ppDetails */

/* cart */
function addToCart(id,n,btn){
  cart[id]=(cart[id]||0)+n; renderCart(); bumpBadge();
  if(btn&&btn.classList.contains('add')){const lbl=btn.textContent;btn.classList.add('pop','added');btn.textContent='Aggiunto';setTimeout(()=>{btn.classList.remove('pop','added');btn.textContent=lbl;},1300);} /* lbl: prima l'etichetta tornava sempre 'Aggiungi', degradando 'Aggiungi al carrello' dopo il primo click */
  showToast(n>1?n+' aggiunti al carrello':'Aggiunto al carrello'); openCart(); announceCart();
}
/* riga SET: e' l'unico consiglio con tre bottiglie e un prezzo barrato, quindi si distingue
   a colpo d'occhio dalle righe singole. Aggiunge i tre oli; lo sconto lo applica renderCart.
   Il barrato dice da dove viene ("presi singolarmente"): e' la somma delle tre bottiglie, non un
   prezzo praticato prima. L'aria-label ripete lo stesso testo del visibile, non una versione piu' ricca. */
function bundleRowHTML(){const ids=Object.keys(PRODUCTS);const pieno=ids.reduce((a,id)=>a+PRODUCTS[id].price,0);
  return `<button class="brow" type="button" data-set="1" aria-label="Aggiungi il Rituale completo, tre oli a ${eur(SET_PRICE)} invece di ${eur(pieno)} presi singolarmente"><span class="brow__imgs">${ids.map(id=>bottleImg(PRODUCTS[id],'brow__b')).join('')}</span><span class="brow__m"><span class="brow__name">Il Rituale completo</span><span class="brow__meta"><b>${eur(SET_PRICE)}</b> <s>${eur(pieno)}</s><small class="brow__ps">presi singolarmente</small></span></span><span class="xrow__add">Aggiungi</span></button>`;}
/* riga olio (bottiglia reale + aggiunta rapida) — usata da cross-sell e stato vuoto.
   Stessa griglia della riga di carrello: un solo linguaggio nel pannello, non schede + righe.
   È un <button>: un solo tap target per riga, e il click lo prende la delega su [data-add]. */
function xrowHTML(id){const p=PRODUCTS[id];return `<button class="xrow" type="button" data-add="${id}" style="--oil:${p.color}" aria-label="Aggiungi ${p.name} al carrello, ${eur(p.price)}"><span class="xrow__img">${bottleImg(p,'xbottle')}<span class="xrow__refl" aria-hidden="true">${bottleImg(p,'xrefl')}</span></span><span class="xrow__m"><span class="xrow__name">${p.name}</span><span class="xrow__meta">${eur(p.price)} · <b>${p.intLabel}</b></span></span><span class="xrow__add">Aggiungi</span></button>`;}
function renderCart(refocus){
  const box=document.getElementById('items'); const ids=Object.keys(cart); const allIds=Object.keys(PRODUCTS); let sub=0,count=0;
  const keepScroll=box.scrollTop; /* innerHTML azzera lo scroll: senza questo la lista salta in cima a ogni "+" */
  box.classList.toggle('items--empty', !ids.length);
  const missing=allIds.filter(id=>!cart[id]);
  if(!ids.length){
    /* niente illustrazione: la mascotte-oliva è già fuori dal resto del sito, e qui a vendere
       sono le bottiglie vere. Solo tipografia, filo d'oro e i tre oli. */
    box.innerHTML=`<div class="empty">
      <p class="empty__eyebrow">The Ritual</p>
      <h4>Il tuo rito<br>comincia qui.</h4>
      <p>Tre oli del Gargano, un rito diverso per ogni giorno.</p>
      <span class="empty__filo" aria-hidden="true"></span>
      <div class="xsell"><div class="xsell__grid">${bundleRowHTML()}${allIds.map(xrowHTML).join('')}</div></div>
    </div>`;
  } else {
    const lines=ids.map(id=>{const p=PRODUCTS[id],q=cart[id];sub+=p.price*q;count+=q;
      const unit=q>1?`<span class="line__u">${eur(p.price)} × ${q}</span>`:''; /* niente conti a ritroso */
      return `<div class="line" data-line="${id}" style="--oil:${p.color}"><div class="line__img">${bottleImg(p,'libottle')}</div><div class="line__m"><h4>${p.name}</h4><span class="line__cv"><b>${p.intLabel}</b> · 500 ml</span></div><div class="line__p">${eur(p.price*q)}${unit}</div><div class="lctrl"><div class="lq"><button type="button" data-q="-" data-id="${id}"${q<=1?' disabled':''} aria-label="Diminuisci la quantità di ${p.name}, ora ${q}">−</button><span aria-hidden="true">${q}</span><button type="button" data-q="+" data-id="${id}"${q>=MAX_QTY?' disabled':''} aria-label="Aumenta la quantità di ${p.name}, ora ${q}">+</button></div><button type="button" class="lrm" data-rm="${id}" aria-label="Rimuovi ${p.name} dal carrello">Rimuovi</button></div></div>`;}).join('');
    /* il blocco consigli ha un peso visivo diverso dalla lista: bottiglie piccole, riga compatta,
       fondo velato. Cosi' "quello che hai" e "quello che ti propongo" non si confondono piu'. */
    const sugg = missing.length
      ? `<div class="xsell"><p class="xsell__h">Completa il rituale</p><div class="xsell__grid">${missing.length>1?bundleRowHTML():''}${missing.map(xrowHTML).join('')}</div></div>`
      : '';
    box.innerHTML=`<div class="mine">${lines}</div>${sugg}`;
  }
  box.scrollTop=keepScroll;
  count=ids.reduce((a,id)=>a+cart[id],0);
  saveCart();
  /* set completi nel carrello: il sito pubblica "€59 invece di €66 presi singolarmente", ma addToCart sommava
     sempre 66. Qui lo sconto viene applicato davvero, cosi' il carrello non smentisce la pagina.
     Nessun numero nuovo: 59 e 66 sono gia' pubblicati in olio-home.liquid. */
  const sets = allIds.length ? Math.min(...allIds.map(id=>cart[id]||0)) : 0;
  const saving = sets * (allIds.reduce((a,id)=>a+PRODUCTS[id].price,0) - SET_PRICE);
  const tot = Math.max(0, sub - saving);
  const setRow=document.getElementById('dsetRow');
  if(setRow){
    setRow.hidden = saving<=0;
    setRow.querySelector('.dset__v').textContent = '−'+eur(saving);
    setRow.querySelector('.dset__k').textContent = sets>1 ? `Rituale completo × ${sets}` : 'Rituale completo';
  }
  document.getElementById('subtotal').textContent=eur(tot);
  const chip=document.getElementById('cntChip'); chip.textContent=count===1?'1 bottiglia':count+' bottiglie'; chip.style.display=count?'block':'none';
  const co=document.getElementById('checkout'); co.disabled=!count;
  [['badgeTop']].forEach(([bid])=>{const b=document.getElementById(bid);b.textContent=count;b.style.display=count?'flex':'none';});
  const _cb=document.getElementById('openCartTop');
  if(_cb) _cb.setAttribute('aria-label', count ? `Carrello, ${count} ${count===1?'articolo':'articoli'}` : 'Carrello, vuoto'); /* aria-label copriva il contenuto: il conteggio non veniva mai letto */
  /* piede e soglia spedizione si nascondono a carrello vuoto: un subtotale a zero,
     una CTA morta e una barra ferma allo 0% sono rumore, non informazione. */
  const ft=document.querySelector('.dft'); if(ft) ft.classList.toggle('is-empty', !count);
  const ship=document.querySelector('.ship');
  const bottlesLeft=FREE_SHIP?Math.max(0,Math.ceil((FREE_SHIP-tot)/MIN_PRICE)):0;
  if(ship){
    ship.hidden=!count||!FREE_SHIP;
    ship.classList.toggle('unlocked', count>0 && bottlesLeft<=0);
  }
  /* in bottiglie, non in euro: con tutti gli oli allo stesso prezzo i subtotali sono multipli
     del prezzo unitario, quindi "ti mancano €17" era una distanza non percorribile. */
  document.getElementById('shipMsg').innerHTML=bottlesLeft>0
    ? `Ancora <b>${bottlesLeft===1?'una bottiglia':bottlesLeft+' bottiglie'}</b> e la spedizione è nostra`
    : 'Spedizione inclusa';
  document.getElementById('shipFill').style.width=(FREE_SHIP?Math.min(100,tot/FREE_SHIP*100):0)+'%';
  if(refocus){
    const t=box.querySelector(refocus);
    if(t&&t.focus&&!t.disabled){ t.focus(); }
    else { const c=document.getElementById('closeCart'); if(c&&drawer.classList.contains('open')) c.focus(); }
  }
}
/* una sola live region, con una frase costruita a mano: mettere aria-live su #items
   farebbe rileggere l'intero pannello a ogni "+". */
function announceCart(){
  const live=document.getElementById('cartLive'); if(!live) return;
  const ids=Object.keys(cart);
  const n=ids.reduce((a,id)=>a+cart[id],0);
  const sub=ids.reduce((a,id)=>a+PRODUCTS[id].price*cart[id],0);
  live.textContent=n?`Carrello aggiornato: ${n} ${n===1?'bottiglia':'bottiglie'}, subtotale ${eur(sub)}.`:'Il carrello è vuoto.';
}
document.getElementById('items').addEventListener('click',e=>{
  const q=e.target.closest('[data-q]');
  if(q){
    const id=q.getAttribute('data-id'), dir=q.getAttribute('data-q');
    const next=cart[id]+(dir==='+'?1:-1);
    if(next<1||next>MAX_QTY) return;            /* "−" a 1 non cancella più di nascosto: c'è "Rimuovi" */
    cart[id]=next;
    renderCart(`[data-q="${dir}"][data-id="${id}"]`); /* il bottone premuto viene distrutto dal re-render: va rimesso a fuoco */
    bumpBadge(); announceCart(); return;
  }
  const st=e.target.closest('[data-set]');
  if(st){ Object.keys(PRODUCTS).forEach(id=>{cart[id]=(cart[id]||0)+1;}); renderCart(null); bumpBadge(); announceCart(); showToast('Il Rituale completo nel carrello'); return; }
  const rm=e.target.closest('[data-rm]');
  if(rm){ delete cart[rm.getAttribute('data-rm')]; renderCart(null); bumpBadge(); announceCart(); }
});
function bumpBadge(){['badgeTop'].forEach(id=>{const b=document.getElementById(id);b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump');});}

/* drawer — stesso pattern di dialog già usato per #infoModal e #nlpop:
   fuoco che entra, resta dentro e torna al bottone che ha aperto. Senza, aprire il
   carrello con uno screen reader non produceva nulla (il lettore restava dov'era)
   e da tastiera si tabbava dentro un pannello invisibile. */
const drawer=document.getElementById('drawer'),overlay=document.getElementById('overlay');
let cartLastFocus=null;
function cartFocusables(){
  return [].slice.call(drawer.querySelectorAll('button:not([disabled]),[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'))
    .filter(function(el){ return el.offsetParent!==null; });
}
function cartTrap(e){
  if(!drawer.classList.contains('open')) return;
  if(e.key==='Escape'){ e.stopPropagation(); closeCart(); return; }
  if(e.key!=='Tab') return;
  const f=cartFocusables(); if(!f.length) return;
  const first=f[0], last=f[f.length-1], inside=drawer.contains(document.activeElement);
  if(e.shiftKey && (!inside || document.activeElement===first)){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && (!inside || document.activeElement===last)){ e.preventDefault(); first.focus(); }
}
const openCart=()=>{
  if(drawer.classList.contains('open')) return;
  cartLastFocus=document.activeElement;
  drawer.classList.add('open','is-entering');
  drawer.removeAttribute('inert');
  overlay.classList.add('open');
  document.body.style.overflow='hidden';
  document.addEventListener('keydown',cartTrap,true);
  setTimeout(()=>drawer.classList.remove('is-entering'),900);
  const tab = document.getElementById('nltab');
  if(tab) tab.style.setProperty('display', 'none', 'important');
  const popClose = document.getElementById('nlpopClose');
  const pop = document.getElementById('nlpop');
  if(pop && pop.classList.contains('open') && popClose) popClose.click();
  setTimeout(()=>{ drawer.focus({preventScroll:true}); },60); /* il pannello, non il bottone Chiudi: cosi' non si accende l'anello di fuoco a ogni apertura */
};
const closeCart=()=>{
  if(!drawer.classList.contains('open')) return;
  drawer.classList.remove('open');
  overlay.classList.remove('open');
  document.body.style.overflow='';
  document.removeEventListener('keydown',cartTrap,true);
  drawer.setAttribute('inert','');
  const tab = document.getElementById('nltab');
  if(tab) tab.style.removeProperty('display');
  if(cartLastFocus && cartLastFocus.focus) cartLastFocus.focus();
};
document.getElementById('openCartTop').onclick=openCart;
syncNav(curPage); /* stato attivo al primo caricamento */
/* onda del drawer rimossa: dipingeva la crema vecchia #F4EFE3 (palette sostituita) ed era
   un pattern "onde divisorie" già disattivato altrove. Al suo posto un filo d'oro in CSS. */

/* hero: campo blob rimosso — lo sfondo animato lascia il posto al video loop */
/* ===== menu mobile: pannello a tutto schermo =====
   Prima era un toggle di una classe e basta: la pagina sotto restava
   scrollabile, Esc non chiudeva, il fuoco da tastiera usciva dal pannello e
   non tornava al bottone. Stesso contratto del drawer del carrello. */
(function(){
  const burger=document.getElementById('burger'), menu=document.getElementById('menu');
  if(!burger || !menu) return;
  const hd=document.querySelector('.hd');
  let lastFocus=null, chromeTimer=0;

  const isOpen=()=>menu.classList.contains('open');
  const focusables=()=>[].slice.call(menu.querySelectorAll('a[href],button:not([disabled])'))
    .filter(el=>el.offsetParent!==null);

  function trap(e){
    if(!isOpen()) return;
    if(e.key==='Escape'){ e.stopPropagation(); close(); return; }
    if(e.key!=='Tab') return;
    /* il bottone burger sta FUORI dal pannello ma e' la X che lo chiude:
       entra nel giro, altrimenti col Tab si finisce sulla pagina sotto. */
    const f=focusables().concat([burger]);
    if(!f.length) return;
    const first=f[0], last=f[f.length-1];
    const inside=menu.contains(document.activeElement)||document.activeElement===burger;
    if(e.shiftKey && (!inside||document.activeElement===first)){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && (!inside||document.activeElement===last)){ e.preventDefault(); first.focus(); }
  }

  function open(){
    if(isOpen()) return;
    lastFocus=document.activeElement;
    /* l'altezza vera della navbar (padding compresi) decide dove comincia il
       pannello: con un valore fisso la prima voce finiva sotto il logo. */
    if(hd) document.documentElement.style.setProperty('--hd-h', hd.offsetHeight+'px');
    if(hd) hd.classList.remove('hd--hidden'); /* se la navbar si era ritratta, la X sparirebbe */
    menu.removeAttribute('inert');
    menu.classList.add('open');
    /* la navbar passa ai colori scuri SOLO quando il pannello l'ha raggiunta.
       Il logo si scambia con display: non e' transizionabile, quindi senza
       questo ritardo il logo scuro lampeggiava sul video scuro per mezzo
       secondo, durante la risalita. */
    clearTimeout(chromeTimer);
    chromeTimer=setTimeout(()=>document.body.classList.add('mnav-open'),430);
    document.body.style.overflow='hidden';
    burger.setAttribute('aria-expanded','true');
    document.addEventListener('keydown',trap,true);
    const tab=document.getElementById('nltab');
    if(tab) tab.style.setProperty('display','none','important');
    setTimeout(()=>{ const f=focusables()[0]; if(f) f.focus({preventScroll:true}); },80);
  }

  function close(refocus){
    if(!isOpen()) return;
    menu.classList.remove('open');
    clearTimeout(chromeTimer); /* chiuso prima dei 430ms: la navbar non deve scurirsi dopo */
    document.body.classList.remove('mnav-open');
    document.body.style.overflow='';
    burger.setAttribute('aria-expanded','false');
    document.removeEventListener('keydown',trap,true);
    menu.setAttribute('inert','');
    const tab=document.getElementById('nltab');
    if(tab) tab.style.removeProperty('display');
    if(refocus!==false && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  burger.addEventListener('click',()=>{ isOpen()?close():open(); });
  /* la voce cliccata cambia pagina (go() ci pensa il delegato globale): qui si
     chiude soltanto, senza riportare il fuoco al burger — sarebbe un salto
     all'indietro rispetto alla pagina appena aperta. */
  menu.addEventListener('click',e=>{ if(e.target.closest('a')) close(false); });
  /* ruotando il telefono in orizzontale si passa sopra i 760px: il pannello
     sparirebbe per CSS lasciando lo scroll bloccato e il body con la classe. */
  window.addEventListener('resize',()=>{ if(isOpen() && window.innerWidth>760) close(false); });
})();

/* account dropdown (desktop): apri/chiudi con click + ESC, click-fuori, frecce, focus gestito. Voci = segnaposto (pagine native Shopify). */
(function(){
  const btn=document.getElementById('acctBtn'), m=document.getElementById('acctMenu');
  if(btn && m){
    const items=()=>[].slice.call(m.querySelectorAll('a'));
    const onDoc=(e)=>{ if(!m.contains(e.target) && !btn.contains(e.target)) closeM(false); };
    const onKey=(e)=>{
      if(e.key==='Escape'){ closeM(true); }
      else if(e.key==='ArrowDown'||e.key==='ArrowUp'){ e.preventDefault(); const it=items(); let i=it.indexOf(document.activeElement); i=e.key==='ArrowDown'?(i+1)%it.length:(i-1+it.length)%it.length; it[i].focus(); }
    };
    function openM(){ m.classList.add('open'); btn.setAttribute('aria-expanded','true'); document.addEventListener('click',onDoc); document.addEventListener('keydown',onKey); const f=items()[0]; if(f) setTimeout(()=>f.focus(),40); }
    function closeM(focusBtn){ m.classList.remove('open'); btn.setAttribute('aria-expanded','false'); document.removeEventListener('click',onDoc); document.removeEventListener('keydown',onKey); if(focusBtn) btn.focus(); }
    btn.addEventListener('click',(e)=>{ e.stopPropagation(); btn.getAttribute('aria-expanded')==='true'?closeM(false):openM(); });
  }
  // login/registrazione/ordini: portano davvero alle pagine account di Shopify (routes.account_*)
  document.querySelectorAll('[data-acct]').forEach(a=>{
    const url=(window.OLIO_ROUTES||{})[a.getAttribute('data-acct')];
    if(url) a.href=url;
    a.addEventListener('click',()=>{ if(m) m.classList.remove('open'); if(btn) btn.setAttribute('aria-expanded','false'); });
  });
})();
document.getElementById('closeCart').onclick=closeCart; overlay.onclick=closeCart;
/* Esc: gestito da cartTrap solo quando il drawer è aperto. La versione globale che stava
   qui chiudeva il carrello anche insieme ad altri modali, senza restituire il fuoco. */
/* checkout vero: il carrello del sito resta locale (serve alla UI custom), ma qui viene tradotto
   negli id di variante reali e mandato al carrello/checkout di Shopify. Un set completo (min tra
   origine/anima/alchimia) diventa una riga del prodotto-bundle "Il Rituale completo" a 59€, il resto
   resta oli singoli — stessa matematica che renderCart mostra gia' nel pannello, ora e' anche reale. */
let checkoutBusy=false; /* doppio click / doppio tap: senza guardia partivano due clear+add in parallelo */
document.getElementById('checkout').onclick=async(e)=>{
  if(checkoutBusy) return;
  const ids=Object.keys(PRODUCTS);
  if(!Object.keys(cart).length){ showToast('Il carrello è vuoto'); return; }
  const V=window.OLIO_VARIANTS||{}, R=window.OLIO_ROUTES||{};

  /* Nessuna riga puo' sparire in silenzio: se manca l'id di variante di un olio che sta nel
     carrello, il checkout consegnerebbe MENO di quanto mostrato e incasserebbe di meno.
     Meglio fermarsi e dirlo che spedire un ordine monco. */
  const orfani=ids.filter(id=>(cart[id]||0)>0 && !V[id]);
  if(orfani.length){
    showToast('Un prodotto non è disponibile in questo momento — riprova tra poco');
    return;
  }

  const sets=Math.min(...ids.map(id=>cart[id]||0));
  const items=[];
  ids.forEach(id=>{ const rest=(cart[id]||0)-sets; if(rest>0) items.push({id:V[id],quantity:rest}); });
  if(sets>0){
    if(V.bundle) items.push({id:V.bundle,quantity:sets});
    else {
      /* bundle non collegato: si puo' comunque comprare, ma a prezzo pieno. Va DETTO,
         altrimenti il drawer segna 59 e il checkout ne chiede 66. */
      ids.forEach(id=>{ items.push({id:V[id],quantity:sets}); });
      showToast('Lo sconto del set non è disponibile ora: gli oli vengono aggiunti singolarmente');
    }
  }
  if(!items.length || !R.cartAdd){ showToast('Carrello non collegato — riprova tra poco'); return; }

  const btn=e.currentTarget, lbl=btn.textContent;
  checkoutBusy=true; btn.disabled=true; btn.textContent='Un momento…';
  const J={'Content-Type':'application/json','Accept':'application/json'}; /* senza Accept l'Ajax API puo' rispondere con un redirect HTML e res.ok resta true */
  try{
    const clr=await fetch(R.cartClear||'/cart/clear.js',{method:'POST',headers:J});
    if(!clr.ok) throw new Error('cart clear fallito: '+clr.status);
    const res=await fetch(R.cartAdd,{method:'POST',headers:J,body:JSON.stringify({items})});
    if(!res.ok){
      let msg=''; try{ const j=await res.json(); msg=j.description||j.message||''; }catch(_){}
      throw new Error('cart add fallito: '+res.status+' '+msg);
    }
    window.location.href=R.checkout||'/checkout';
  }catch(err){
    console.error('[olio] checkout:',err);
    checkoutBusy=false; btn.disabled=false; btn.textContent=lbl;
    showToast('Non riusciamo ad aprire il checkout — riprova fra un istante');
  }
};
/* iscrizione newsletter vera: stesso contratto del form nativo Shopify {% form 'customer' %}
   (POST /contact, form_type=customer, contact[tags]=newsletter) ma via fetch per restare nella SPA. */
function subscribeNewsletter(email,extraTag){
  const tags=['newsletter'].concat(extraTag?[extraTag]:[]).join(',');
  const body=new URLSearchParams({form_type:'customer',utf8:'✓','contact[email]':email,'contact[tags]':tags});
  /* fetch NON rifiuta sui 4xx/5xx: senza questo controllo si mostrava "Iscritto!" anche quando
     Shopify aveva rifiutato l'indirizzo, e si salvava subscribed=true in localStorage. */
  return fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:body.toString()})
    .then(res=>{ if(!res.ok) throw new Error('iscrizione fallita: '+res.status); return res; });
}
document.getElementById('clubForm').onsubmit=async(e)=>{
  e.preventDefault();
  const input=e.target.querySelector('input[type="email"]'), v=(input.value||'').trim();
  if(!v) return;
  const btn=e.target.querySelector('[type="submit"]'); if(btn) btn.disabled=true;
  try{ await subscribeNewsletter(v); showToast('Iscrizione registrata'); e.target.reset(); }
  catch(err){ console.error('[olio] newsletter:',err); showToast('Non siamo riusciti a registrare l’indirizzo — riprova'); }
  finally{ if(btn) btn.disabled=false; }
};

/* telefono e social: campi NATIVI Shopify (OLIO_CONTACT, iniettato in olio-home.liquid da
   shop.phone e settings.social_*_link) — il cliente li compila dall'admin, non da qui. Vivono
   nella colonna "Scrivici" del footer (presente su ogni pagina, la pagina Contatti ora ha solo
   form e mappa). Finche' sono vuoti (oggi lo sono tutti) resta un promemoria leggero — sparisce
   da solo appena il cliente compila i campi in admin, senza bisogno di un altro deploy. */
(function(){
  const C=window.OLIO_CONTACT||{};
  const socials=[C.instagram&&{label:'Instagram',url:C.instagram},C.tiktok&&{label:'TikTok',url:C.tiktok}].filter(Boolean);

  const phoneEl=document.getElementById('ftPhone');
  if(phoneEl) phoneEl.innerHTML = C.phone
    ? `<a href="tel:${C.phone.replace(/[^\d+]/g,'')}">${C.phone}</a>`
    : `<span class="ft__todo">Telefono &mdash; da inserire in Impostazioni negozio &rarr; Generali</span>`;

  const socialEl=document.getElementById('ftSocial');
  if(socialEl) socialEl.innerHTML = socials.length
    ? socials.map(s=>`<a href="${s.url}" target="_blank" rel="noopener">${s.label}</a>`).join('')
    : `<span class="ft__todo">Social &mdash; da inserire in Impostazioni tema &rarr; Social media</span>`;
})();

/* pagina Contatti: stesso contratto del form nativo Shopify {% form 'contact' %}
   (POST /contact, form_type=contact) ma via fetch per restare nella SPA — stesso gesto
   gia' usato per la newsletter (subscribeNewsletter), qui col form_type generico. */
(function(){
  const form=document.getElementById('contactForm'); if(!form) return;
  const ok=document.getElementById('contactOk'), err=document.getElementById('contactErr'), btn=document.getElementById('contactSubmit');
  form.onsubmit=async(e)=>{
    e.preventDefault();
    ok.hidden=true; err.hidden=true;
    const body=new URLSearchParams({
      form_type:'contact', utf8:'✓',
      'contact[name]':form.name.value.trim(),
      'contact[email]':form.email.value.trim(),
      'contact[body]':form.body.value.trim()
    });
    btn.disabled=true; const lbl=btn.textContent; btn.textContent='Invio in corso…';
    try{
      const res=await fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:body.toString()});
      if(!res.ok) throw new Error('contact fallito: '+res.status);
      ok.hidden=false; form.reset();
    }catch(e2){
      console.error('[olio] contatti:',e2); err.hidden=false;
    }finally{
      btn.disabled=false; btn.textContent=lbl;
    }
  };
})();

/* toast */
let tT; function showToast(m){const t=document.getElementById('toast');document.getElementById('toastMsg').textContent=m;t.classList.add('show');clearTimeout(tT);tT=setTimeout(()=>t.classList.remove('show'),2200);}

/* reveal */
let io;
function refreshObserve(){
  if(!io)io=new IntersectionObserver(es=>es.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}}),{threshold:.12});
  document.querySelectorAll('.page.active .reveal:not(.in)').forEach(el=>io.observe(el));
  // Aggiorna anche il sistema scroll-reveal .sv dopo il cambio pagina
  if(typeof window.svRefresh==='function') window.svRefresh();
}

/* scroll: parallax + seal rotation + draw lines */
const reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
const drawPaths=[];
document.querySelectorAll('.draw-path').forEach(p=>{const L=p.getTotalLength();p.style.strokeDasharray=L;p.style.strokeDashoffset=reduce?0:L;drawPaths.push({p,L,host:p.closest('[data-draw]')});});
const pars=[...document.querySelectorAll('.par')].map(el=>({el,speed:parseFloat(el.getAttribute('data-speed'))||0,base:0}));
function computeBases(){ if(reduce)return; pars.forEach(o=>{o.el.style.transform='';}); pars.forEach(o=>{const r=o.el.getBoundingClientRect();o.base=r.top+window.scrollY+r.height/2;}); }
let ticking=false;
function onScroll(){
  if(reduce){ticking=false;return;}
  const y=window.scrollY, vh=window.innerHeight;
  pars.forEach(o=>{const center=o.base-y; const off=(vh/2-center)*o.speed; o.el.style.transform='translateY('+off.toFixed(1)+'px)';});
  const seal=document.getElementById('heroSeal'); if(seal)seal.style.transform='rotate('+(y*0.12)+'deg)';
  drawPaths.forEach(({p,L,host})=>{const r=host.getBoundingClientRect();const prog=Math.min(1,Math.max(0,(vh-r.top)/(vh*0.7)));p.style.strokeDashoffset=L*(1-prog);});
  ticking=false;
}
window.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(onScroll);}},{passive:true});
window.addEventListener('resize',()=>{computeBases();onScroll();});

const _go=go; go=function(p,url){_go(p,url);computeBases();onScroll();}; /* url va rigirato: senza, product/article perdevano l'URL reale passato da openProduct/openArticle */
/* reviews wall + certifications */
(function(){
  /* RECENSIONI: vuote per scelta. Qui c'erano 8 recensioni inventate, con badge "verificato"
     e cinque stelle, su uno store con zero ordini: pubblicarle e' una pratica commerciale
     scorretta in ogni caso (all. I Cod. Consumo, nn. 23-bis e 23-ter). Si riempie solo con
     recensioni vere, raccolte dopo un acquisto verificabile. */
  const REVIEWS=[];

  const AVCOL=['#01656D','#D75742','#7C2519','#0A222A','#621D14']; // TODO colori avatar recensioni = segnaposto, da allineare alla palette reale
  function rcard(r){
    const ini=r.n.split(' ').map(s=>s[0]).join('').slice(0,2).toUpperCase();
    let h=0; for(let i=0;i<r.n.length;i++) h=(h+r.n.charCodeAt(i))%AVCOL.length;
    return `<figure class="rcard">
      <div class="rcard__top">
        <span class="rcard__av" style="background:${AVCOL[h]}">${ini}</span>
        <span class="rcard__id"><span class="rcard__name">${r.n}</span><br><span class="rcard__loc">${r.c}</span></span>
        <span class="rcard__ver">✓ verificato</span>
      </div>
      <div class="rcard__s" aria-hidden="true">★★★★★</div>
      <p class="rcard__t">${r.t}</p>
      <p class="rcard__tag">su <b>${r.p}</b></p>
    </figure>`;
  }
  const row=document.getElementById('revRow1');
  if(row) row.innerHTML=REVIEWS.map(rcard).join('')+REVIEWS.map(rcard).join(''); // doppia lista = loop continuo
  /* marquee lento auto + swipe manuale (overflow nativo) + pausa hover; reduced-motion: solo manuale */
  const wall=document.querySelector('.revwall');
  if(wall && row && !matchMedia('(prefers-reduced-motion:reduce)').matches){
    let paused=false;
    wall.addEventListener('mouseenter',()=>paused=true);
    wall.addEventListener('mouseleave',()=>paused=false);
    wall.addEventListener('pointerdown',()=>paused=true);
    window.addEventListener('pointerup',()=>setTimeout(()=>{paused=false;},1200));
    (function tick(){ if(!paused){ wall.scrollLeft+=0.5; const h=wall.scrollWidth/2; if(h>0 && wall.scrollLeft>=h) wall.scrollLeft-=h; } requestAnimationFrame(tick); })();
  }

  /* Niente roundel: il commento in olio-home.liquid lo diceva gia' ("roundel fatti in casa che
     imitano un marchio ufficiale svalutano quello vero"), ma il codice li disegnava lo stesso,
     alloro compreso. Qui restano solo fatti di processo verificabili, senza cornice da medaglia.
     Il BIO NON compare: e' dichiarato solo per Origine e finche' manca il codice dell'organismo
     di controllo (IT-BIO-XXX) e l'Eurofoglia non si puo' esporre come garanzia di linea. */
  function segno(center){
    return `<svg viewBox="0 0 100 102" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${center}</svg>`;
  }
  const SEALS=[
    {c:'<path d="M39,62 C39,49 52,45 62,47 C62,60 49,64 39,62 Z"/><path d="M44,59 L59,49"/>', l:'Raccolta a mano'},
    {c:'<circle cx="50" cy="54" r="20"/><path d="M50,42 v12 l8,5"/>', l:'Molitura entro 12 ore'},
    {c:'<path d="M50,42 C50,42 41,55 41,62 a9,9 0 0 0 18,0 C59,55 50,42 50,42 Z"/>', l:'Spremitura a freddo, sotto i 27°'},
    {c:'<path d="M40,55 l7,7 14,-15"/>', l:'Dal produttore, senza intermediari'},
  ];
  const cr=document.getElementById('certRow');
  if(cr) cr.innerHTML=SEALS.map((s,i)=>`<div class="seal2 reveal" style="transition-delay:${(i*0.08).toFixed(2)}s">${segno(s.c)}<span class="seal2__lab">${s.l}</span></div>`).join('');
})();


/* uses: reveal scaglionato delle icone cibo */
(function(){
  const items=[...document.querySelectorAll('.fchip')];
  if(!items.length) return;
  const io=new IntersectionObserver((es)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in'); io.unobserve(e.target);}}),{threshold:.25, rootMargin:'0px 0px -7% 0px'});
  items.forEach((el,i)=>{ el.style.transitionDelay=(i*0.06).toFixed(2)+'s'; io.observe(el); });
})();

/* CTA "Aggiungi il rito" — UNICA logica riusata da: sezione Bundle (#bundleAdd) e card Set nello Shop (#shopBundleAdd) */
(function(){
  function addRitual(){
    ['origine','anima','alchimia'].forEach(id=>addToCart(id,1)); // aggiunge i 3 oli (apre il drawer); al checkout diventano il prodotto-bundle reale
    showToast('Il Rituale completo nel carrello');
  }
  ['bundleAdd','shopBundleAdd'].forEach(id=>{ const b=document.getElementById(id); if(b) b.addEventListener('click',addRitual); });
})();

/* ===== Chi siamo v3: indice+filo, contatori, FAQ single-open, parallax, progress ===== */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  /* contatori */
  var nums = [].slice.call(document.querySelectorAll('.abnum__v[data-to]'));
  if(nums.length){ var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ runNum(e.target); io.unobserve(e.target);} }); }, {threshold:.4}); nums.forEach(function(n){ io.observe(n); }); }
  function runNum(el){ var to = +el.getAttribute('data-to'), suf = el.getAttribute('data-suffix')||'', pre = el.getAttribute('data-prefix')||'', b = el.querySelector('b'); if(reduce){ b.textContent = pre + to + suf; return; } var dur = 1100, t0 = performance.now(); function tick(t){ var p = Math.min(1,(t-t0)/dur), e = 1-Math.pow(1-p,3); b.textContent = pre + Math.round(to*e) + suf; if(p<1) requestAnimationFrame(tick); } requestAnimationFrame(tick); }
  /* FAQ single-open */
  var faq = document.querySelector('.abfaq');
  if(faq){ var items = [].slice.call(faq.querySelectorAll('.abfaq__item')); var setH = function(a,h){ a.style.height = h; };
    items.forEach(function(it){ var q = it.querySelector('.abfaq__q'), a = it.querySelector('.abfaq__a'), inn = it.querySelector('.abfaq__a-in');
      q.addEventListener('click', function(){ var willOpen = !it.classList.contains('open');
        items.forEach(function(o){ if(o!==it && o.classList.contains('open')){ o.classList.remove('open'); o.querySelector('.abfaq__q').setAttribute('aria-expanded','false'); var oa = o.querySelector('.abfaq__a'); if(reduce){ setH(oa,'0'); } else { setH(oa, oa.scrollHeight+'px'); requestAnimationFrame(function(){ setH(oa,'0'); }); } } });
        if(willOpen){ it.classList.add('open'); q.setAttribute('aria-expanded','true'); if(reduce){ setH(a,'auto'); } else { setH(a, inn.scrollHeight+'px'); a.addEventListener('transitionend', function te(){ if(it.classList.contains('open')) setH(a,'auto'); a.removeEventListener('transitionend', te); }); } }
        else { it.classList.remove('open'); q.setAttribute('aria-expanded','false'); if(reduce){ setH(a,'0'); } else { setH(a, a.scrollHeight+'px'); requestAnimationFrame(function(){ setH(a,'0'); }); } }
      });
    });
  }
  /* indice "barra narrativa": tracking + tema adattivo + filo con riempimento e cursore */
  var links = [].slice.call(document.querySelectorAll('.abidx__i'));
  var idxEl = document.querySelector('.abidx');
  if(links.length && idxEl){
    var fillEl = idxEl.querySelector('.abidx__fill'), curEl = idxEl.querySelector('.abidx__cursor');
    links.forEach(function(l){ l.addEventListener('click', function(){ var t = document.getElementById(l.getAttribute('data-target')); if(t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block:'start' }); }); });
    var allSecs = [].slice.call(document.querySelectorAll('#about section.abx'));
    var chaps = links.map(function(l){ return document.getElementById(l.getAttribute('data-target')); });
    var themeSecs = [].slice.call(document.querySelectorAll('#about .abnbar, #about section.abx'));
    function isDarkSec(el){ return !!el && (el.classList.contains('abx--dark') || el.classList.contains('abh') || el.classList.contains('abnbar')); }
    function updIdxTheme(){ var r = idxEl.getBoundingClientRect(); var cy = r.top + r.height/2; var beh = null; for(var i=0;i<themeSecs.length;i++){ var bb = themeSecs[i].getBoundingClientRect(); if(bb.top <= cy && bb.bottom > cy){ beh = themeSecs[i]; break; } } idxEl.classList.toggle('abidx--light', beh ? isDarkSec(beh) : true); }
    function centers(){ return links.map(function(l){ return l.offsetTop + l.offsetHeight/2 - 9; }); }
    function setFill(cy){ if(fillEl) fillEl.style.height = Math.max(0,cy) + 'px'; if(curEl) curEl.style.transform = 'translateY(' + (cy-6.5) + 'px)'; var cs = centers(); links.forEach(function(l,i){ l.classList.toggle('passed', cs[i] <= cy + 0.5); }); }
    function progressCy(){ var cs = centers(), m = chaps.length; if(!m) return cs[0]||0; var centerY = window.innerHeight*0.5, a = 0; for(var i=0;i<m;i++){ if(chaps[i] && chaps[i].getBoundingClientRect().top <= centerY) a = i; } var r = chaps[a].getBoundingClientRect(), t = (centerY - r.top)/Math.max(1, r.height); t = Math.max(0, Math.min(1, t)); var b = Math.min(a+1, m-1); return cs[a] + (cs[b]-cs[a])*t; }
    var io3 = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var sec = e.target; if(sec.id){ var ai = -1; links.forEach(function(l,i){ var on = l.getAttribute('data-target')===sec.id; l.classList.toggle('on', on); if(on) ai = i; }); if(reduce && ai>=0){ var cs = centers(); setFill(cs[ai]); } } if(!reduce){ requestAnimationFrame(function(){ setFill(progressCy()); }); } } }); }, {rootMargin:'-45% 0px -45% 0px', threshold:0});
    allSecs.forEach(function(s){ io3.observe(s); });
    if(!reduce){ var tk = false; var onScrollFilo = function(){ if(!tk){ tk = true; requestAnimationFrame(function(){ setFill(progressCy()); tk = false; }); } }; window.addEventListener('scroll', onScrollFilo, {passive:true}); window.addEventListener('resize', onScrollFilo); onScrollFilo(); }
    var heroEl = document.querySelector('#about .abh');
    if(heroEl){ var idxTick=false; var updIdx = function(){ var _ft=document.querySelector('.ft');
    idxEl.classList.toggle('abidx--in', heroEl.getBoundingClientRect().bottom < window.innerHeight*0.5 && (!_ft || _ft.getBoundingClientRect().top > window.innerHeight - 30)); /* l indice finiva sopra il footer: il CSS non puo saperlo */ updIdxTheme(); idxTick=false; }; var showIdx = function(){ if(!idxTick){ idxTick=true; requestAnimationFrame(updIdx); } }; window.addEventListener('scroll', showIdx, {passive:true}); window.addEventListener('resize', showIdx); new IntersectionObserver(function(){ showIdx(); }, {threshold:[0,0.5,1]}).observe(heroEl); updIdx(); }
  }
  /* progress bar */
  var fill = document.querySelector('.abprog__fill'), about = document.getElementById('about');
  if(fill && about){ var upP = function(){ var r = about.getBoundingClientRect(); var total = about.offsetHeight - window.innerHeight; var passed = Math.min(Math.max(-r.top,0), Math.max(total,1)); fill.style.width = (total>0 ? (passed/total*100) : 0) + '%'; }; window.addEventListener('scroll', upP, {passive:true}); window.addEventListener('resize', upP); upP(); }
  /* parallax leggero immagini */
  if(!reduce){ var px = [].slice.call(document.querySelectorAll('.zz__media [data-px], .abgesto__media [data-px]')); if(px.length){ var ticking=false; var upd = function(){ var vh = window.innerHeight; px.forEach(function(el){ var h = el.parentElement.getBoundingClientRect(); var c = h.top + h.height/2; var off = (vh/2 - c) * 0.06; el.style.transform = 'translateY(' + off.toFixed(1) + 'px)'; }); ticking=false; }; window.addEventListener('scroll', function(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } }, {passive:true}); window.addEventListener('resize', upd); upd(); } }
  /* manifesto: il titolo si compone parola per parola all'ingresso */
  var mh = document.querySelector('#about .abh__h[data-scrub]');
  if(mh){ if(!('IntersectionObserver' in window)){ mh.classList.add('lit'); } else { var mo = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ mh.classList.add('lit'); mo.disconnect(); } }); }, {threshold:.25}); mo.observe(mh); } }
  /* headings cinetici: i titoli-capitolo si compongono parola per parola (preserva <br> e accenti oro) */
  if(!reduce && 'IntersectionObserver' in window){
    var splitH = function(el){
      var frag = document.createDocumentFragment();
      var pushWords = function(text, target){ text.split(/(\s+)/).forEach(function(tok){ if(tok===''){ return; } if(/^\s+$/.test(tok)){ target.appendChild(document.createTextNode(tok)); } else { var s=document.createElement('span'); s.className='w'; s.textContent=tok; target.appendChild(s); } }); };
      [].slice.call(el.childNodes).forEach(function(n){
        if(n.nodeType===3){ pushWords(n.textContent, frag); }
        else if(n.nodeName==='BR'){ frag.appendChild(document.createElement('br')); }
        else { var w=n.cloneNode(false); [].slice.call(n.childNodes).forEach(function(cn){ if(cn.nodeType===3){ pushWords(cn.textContent, w); } else { w.appendChild(cn.cloneNode(true)); } }); frag.appendChild(w); }
      });
      el.innerHTML=''; el.appendChild(frag);
      [].slice.call(el.querySelectorAll('.w')).forEach(function(w,i){ w.style.transitionDelay = Math.min(i*0.055, 0.7) + 's'; });
      el.classList.add('wsplit');
    };
    [].slice.call(document.querySelectorAll('#about section.abx--cream .abx__h, #about .cap-rito .abx__h')).forEach(function(h){ /* cap-rito è passata a abx--dark: senza questo il titolo del finale perde la composizione parola per parola */
      splitH(h);
      var ko = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ h.classList.add('lit'); ko.disconnect(); } }); }, {threshold:.35});
      ko.observe(h);
    });
  }
  /* il gesto: lo step attivo va in focus mentre la foto resta pinned (sticky via CSS) */
  var gsteps = [].slice.call(document.querySelectorAll('#about .cap-gesto .abgesto__steps li'));
  if(gsteps.length && 'IntersectionObserver' in window){
    var gio = new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.classList.toggle('active', e.isIntersecting); }); }, {rootMargin:'-45% 0px -45% 0px', threshold:0}); // desktop: focus sullo step centrale (foto pinned)
    var gseen = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('seen'); gseen.unobserve(e.target); } }); }, {rootMargin:'0px 0px -12% 0px', threshold:.12}); // mobile: reveal cinematografico una-tantum
    gsteps.forEach(function(s){ gio.observe(s); gseen.observe(s); });
  }
})();

renderCart(); refreshObserve(); computeBases(); onScroll();

/* ===== POP-UP newsletter d'ingresso: trigger 11s | 40% scroll, no se carrello pieno/checkout, 2 step, memoria 7gg, linguetta, focus-trap, scroll-lock ===== */
(function(){
  var pop=document.getElementById('nlpop'), tab=document.getElementById('nltab');
  if(!pop||!tab) return;
  if(/\/(checkout|checkouts)(\/|$)/.test(location.pathname)) return; // mai in checkout
  var KEY='venere_nl', DAY=864e5, WEEK=7*DAY;
  var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var panel=pop.querySelector('.nlpop__panel');
  var closeBtn=document.getElementById('nlpopClose'), noBtn=document.getElementById('nlpopNo'), skip=document.getElementById('nlSkip');
  var form=document.getElementById('nlpopForm'), email=document.getElementById('nlpopEmail');
  var step1=document.getElementById('nlStep1'), step2=document.getElementById('nlStep2');
  var lastFocus=null, shownThisSession=false;
  function state(){ try{ return JSON.parse(localStorage.getItem(KEY))||{}; }catch(e){ return {}; } }
  function save(){ try{ localStorage.setItem(KEY,JSON.stringify(st)); }catch(e){} }
  var st=state();

  var aboutEl=document.getElementById('about');
  if(aboutEl){ var sync=function(){ document.body.classList.toggle('about-active', aboutEl.classList.contains('active')); }; new MutationObserver(sync).observe(aboutEl,{attributes:true,attributeFilter:['class']}); sync(); }

  function cartCount(){ try{ if(typeof cart!=='undefined' && cart) return Object.keys(cart).length; }catch(e){} try{ return document.querySelectorAll('#items .line').length; }catch(e){} return 0; }
  function showTab(){ if(!st.subscribed){ tab.classList.add('show'); requestAnimationFrame(nltabDuckCheck); } }
  function hideTab(){ tab.classList.remove('show'); }

  function focusables(){ return [].slice.call(pop.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function(el){ return el.offsetParent!==null; }); }
  function onKey(e){
    if(e.key==='Escape'){ close(); return; }
    if(e.key!=='Tab') return;
    var f=focusables(); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
  function focusFirst(){ setTimeout(function(){ var scope=(step2 && !step2.hidden)?step2:step1; var f=scope && scope.querySelector('button, input, [href]'); if(!f) f=focusables()[0]; if(f) f.focus(); }, reduce?0:90); }

  function resetSteps(){
    step1.hidden=false; step1.classList.remove('is-out','is-in');
    step2.hidden=true; step2.classList.remove('is-out','is-in');
  }
  function goStep2(){
    if(reduce){ step1.hidden=true; step2.hidden=false; if(email) email.focus(); return; }
    step1.classList.add('is-out');
    setTimeout(function(){
      step1.hidden=true; step1.classList.remove('is-out');
      step2.hidden=false; step2.classList.add('is-in');
      requestAnimationFrame(function(){ step2.classList.remove('is-in'); });
      setTimeout(function(){ if(email) email.focus(); }, 130);
    }, 300);
  }

  function open(){
    if(pop.classList.contains('open')) return;
    lastFocus=document.activeElement;
    resetSteps();
    pop.classList.add('open'); pop.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    hideTab();
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function(){ pop.classList.add('in'); });
    focusFirst();
  }
  function close(){
    if(!pop.classList.contains('open')) return;
    pop.classList.remove('in');
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow='';
    if(reduce){ pop.classList.remove('open'); pop.setAttribute('aria-hidden','true'); }
    else setTimeout(function(){ pop.classList.remove('open'); pop.setAttribute('aria-hidden','true'); }, 380);
    if(!st.subscribed){ st.dismissedAt=Date.now(); save(); showTab(); }
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // STEP 1: scelta preferenza -> salva pref -> STEP 2
  [].slice.call(pop.querySelectorAll('.nlpop__opt')).forEach(function(b){
    b.addEventListener('click', function(){ st.pref=b.getAttribute('data-pref'); save(); goStep2(); });
  });
  if(skip) skip.addEventListener('click', close);

  // STEP 2: iscrizione vera (POST /contact), poi mostra il codice sconto reale BENVENUTO10
  if(form){ form.addEventListener('submit', async function(e){
    e.preventDefault();
    var v=(email.value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){ email.classList.add('err'); email.focus(); return; }
    email.classList.remove('err');
    var submitBtn=form.querySelector('[type="submit"]'); if(submitBtn) submitBtn.disabled=true;
    try{
      await subscribeNewsletter(v, st.pref);
      st.subscribed=true; st.dismissedAt=Date.now(); save(); hideTab();
      step2.innerHTML='<div class="nlpop__ok"><h2>Ecco il tuo <em>10% &#127807;</em></h2><p>Usa questo codice al checkout sul primo ordine:</p><span class="nlpop__code">BENVENUTO10</span><p style="margin-top:14px;font-size:13px;color:var(--muted)">Controlla la mail: ti scriviamo a '+v.replace(/[<>]/g,'')+'.</p></div>';
    }catch(err){
      if(submitBtn) submitBtn.disabled=false;
      email.classList.add('err');
      showToast('Errore di connessione, riprova');
    }
  }); }

  closeBtn.addEventListener('click', close);
  noBtn.addEventListener('click', close);
  pop.addEventListener('click', function(e){ if(e.target.closest('.nlpop__inner') || e.target.closest('.nlpop__close')) return; close(); }); // click fuori dal contenuto
  tab.addEventListener('click', open);

  // stato iniziale
  if(st.subscribed){ hideTab(); return; }
  var ftBase = document.querySelector('.ft__base');
  var duckRAF = false;
  var nltabDuckCheck = function(){ if(!ftBase) return; var br = ftBase.getBoundingClientRect(); var vh = window.innerHeight; var tr = tab.getBoundingClientRect(); var tabTop = tr.height>0 ? tr.top : (vh-84); tab.classList.toggle('nltab--duck', (br.top < vh) && (br.bottom > tabTop-10)); };
  var onDuckScroll = function(){ if(!duckRAF){ duckRAF = true; requestAnimationFrame(function(){ duckRAF = false; nltabDuckCheck(); }); } };
  window.addEventListener('scroll', onDuckScroll, {passive:true});
  window.addEventListener('resize', onDuckScroll);
  nltabDuckCheck();
  if(st.dismissedAt){ showTab(); }
  var canAuto = !st.dismissedAt || (Date.now()-st.dismissedAt > WEEK);
  if(canAuto){
    var fired=false, t=null;
    var onScrollTrig=function(){ var h=document.documentElement.scrollHeight-window.innerHeight; if(h>0 && window.scrollY/h>=0.40) fire(); };
    function cleanup(){ if(t) clearTimeout(t); window.removeEventListener('scroll', onScrollTrig); }
    function fire(){ if(fired||shownThisSession) return; var d=document.getElementById('drawer'); if(cartCount()>0 || (d && d.classList.contains('open'))){ cleanup(); return; } fired=true; shownThisSession=true; cleanup(); open(); }
    t=setTimeout(fire, 11000);
    window.addEventListener('scroll', onScrollTrig, {passive:true});
  }
})();

/* spotlight cursore sul wordmark footer — solo desktop (hover:hover) */
(function(){
  if(!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var wm=document.querySelector('.ft__wordmark'), glow=document.querySelector('.ft__wordmark-glow'), ft=document.querySelector('.ft');
  if(!wm||!glow||!ft) return;
  var mx=0, my=0, tick=false, lit=false;
  function apply(){ tick=false; var r=glow.getBoundingClientRect(); var inside = mx>=r.left && mx<=r.right && my>=r.top && my<=r.bottom; if(inside){ wm.style.setProperty('--spot-x',(mx-r.left)+'px'); wm.style.setProperty('--spot-y',(my-r.top)+'px'); if(!lit){ lit=true; wm.classList.add('is-lit'); } } else if(lit){ lit=false; wm.classList.remove('is-lit'); } }
  ft.addEventListener('mousemove', function(e){ mx=e.clientX; my=e.clientY; if(!tick){ tick=true; requestAnimationFrame(apply); } }, {passive:true});
  ft.addEventListener('mouseleave', function(){ if(lit){ lit=false; wm.classList.remove('is-lit'); } });
})();

/* ============================================================
   SCROLL-REVEAL — motore principale (.sv)
   Principio: leggero, vanilla, senza librerie.
   - osserva tutti gli elementi .sv nel DOM (e quelli aggiunti dinamicamente tramite svObserve())
   - supporta [data-delay="ms"] per delay custom
   - supporta [data-stagger] sul wrapper: i figli .sv ricevono --sv-i crescente
   - rispetta prefers-reduced-motion (se attivo, rende visibile immediatamente)
   ============================================================ */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // IntersectionObserver condiviso per tutti gli .sv
  var svObserver = null;

  function svMakeVisible(el){
    el.classList.add('is-visible');
    svObserver && svObserver.unobserve(el);
  }

  function svInit(){
    if(reduce){
      // Nessuna animazione: rendi tutti visibili subito
      document.querySelectorAll('.sv').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }

    if(!('IntersectionObserver' in window)){
      // Browser molto vecchi: mostra tutto
      document.querySelectorAll('.sv').forEach(function(el){ el.style.opacity=1; el.style.transform='none'; });
      return;
    }

    svObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          // Leggi data-delay se presente
          var delay = el.getAttribute('data-delay');
          if(delay && !reduce){
            setTimeout(function(){ svMakeVisible(el); }, parseInt(delay, 10));
          } else {
            svMakeVisible(el);
          }
        }
      });
    }, {
      rootMargin: '0px 0px -60px 0px', // trigger quando è 60px dentro la viewport
      threshold: 0.08
    });

    // Osserva tutti gli .sv esistenti
    window.svObserveEl = function(el){
      if(!el.classList.contains('is-visible')) svObserver.observe(el);
    };
    document.querySelectorAll('.sv').forEach(window.svObserveEl);
  }

  // Gestisci [data-stagger]: assegna --sv-i ai figli .sv
  function applyStagger(){
    document.querySelectorAll('[data-stagger]').forEach(function(wrap){
      var children = wrap.querySelectorAll(':scope > .sv');
      children.forEach(function(child, i){
        child.style.setProperty('--sv-i', i);
      });
    });
  }

  // Aggiungi classi .sv agli elementi delle sezioni principali
  // (solo la prima volta, non ridipendere se già assegnate)
  function tagSections(){
    // Helper: aggiunge .sv se non già presente
    function tag(sel, mod){
      document.querySelectorAll(sel).forEach(function(el){
        if(!el.classList.contains('sv')){
          el.classList.add('sv');
          if(mod) el.classList.add('sv--'+mod);
        }
      });
    }
    function tagDelay(sel, delay, mod){
      document.querySelectorAll(sel).forEach(function(el){
        if(!el.classList.contains('sv')){
          el.classList.add('sv');
          if(mod) el.classList.add('sv--'+mod);
          if(delay) el.setAttribute('data-delay', delay);
        }
      });
    }

    // NOTA: hero__eyebrow, hero__h, hero__cta2 NON usano .sv —
    // le loro animazioni sono gestite in CSS puro (@keyframes heroEyebrowIn ecc.)
    // Questo garantisce che il contenuto above-the-fold sia sempre visibile
    // anche se JS è lento o disabilitato.

    // Sezione Story: la sezione ha già il suo JS di scroll; taghiamo solo il titolo
    tag('.story__head .eyebrow', 'fade');
    tag('.story__h', 'fade');

    // Sezione Ritual (intestazione kicker)
    tag('.caro__kicker', 'fade');

    // Sezione Bundle
    tag('.bundle__eyebrow', 'fade');
    tag('.bundle__h');
    tagDelay('.bundle__sub', 120);
    tagDelay('.bundle__price', 180);
    tagDelay('.bundle__cta', 260);

    // Sezione Uses
    tag('.uses__head .eyebrow', 'fade');
    tag('.uses__h');
    tagDelay('.uses__sub', 100);
    tag('.uses__player', 'scale');

    // Sezione Founder — la foto e' visibile subito, niente animazione d'entrata
    tag('.founder__ey', 'fade');
    tag('.founder h2');
    tagDelay('.founder__teaser', 80);
    tagDelay('.founder__stats', 160);
    tagDelay('.founder__quote', 220);
    tagDelay('.founder .btn', 300);

    // Sezione Reviews
    tag('.reviews__h', 'fade');
    tagDelay('.rev__line', 100, 'fade');
    tagDelay('.revwall', 160);

    // Sezione Certs
    tag('.certrow', 'scale');

    // Sezione Club
    tag('.club__box');

    // Footer wordmark (solo la firma grande)
    tag('.ft__wordmark', 'fade');

  }

  // Inizializzazione al caricamento
  document.addEventListener('DOMContentLoaded', function(){
    tagSections();
    applyStagger();
    svInit();
  });

  // Re-osserva dopo il cambio pagina (chiamata da go())
  window.svRefresh = function(){
    tagSections();
    applyStagger();
    if(!reduce && svObserver){
      document.querySelectorAll('.sv').forEach(window.svObserveEl);
    }
  };
})();

/* ===== grana da pellicola — velo texture globale, sottilissimo, non interattivo ===== */
(function(){
  if(document.querySelector('.olio-grain')) return;
  var g=document.createElement('div'); g.className='olio-grain'; g.setAttribute('aria-hidden','true');
  document.body.appendChild(g);
})();

/* ===== tipografia cinetica site-wide: i titoli-sezione si compongono parola per parola all'ingresso.
   Esclusi hero (ha già heroHIn) e story (sezione scroll dedicata). Preserva <br> ed elementi/accenti. ===== */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce || !('IntersectionObserver' in window)) return;
  function splitH(el){
    if(el.__split) return; el.__split=true;
    var frag=document.createDocumentFragment();
    var pushWords=function(text,target){ text.split(/(\s+)/).forEach(function(tok){ if(tok==='') return; if(/^\s+$/.test(tok)){ target.appendChild(document.createTextNode(tok)); } else { var s=document.createElement('span'); s.className='w'; s.textContent=tok; target.appendChild(s); } }); };
    [].slice.call(el.childNodes).forEach(function(n){
      if(n.nodeType===3){ pushWords(n.textContent,frag); }
      else if(n.nodeName==='BR'){ frag.appendChild(document.createElement('br')); }
      else { var w=n.cloneNode(false); [].slice.call(n.childNodes).forEach(function(cn){ if(cn.nodeType===3){ pushWords(cn.textContent,w); } else { w.appendChild(cn.cloneNode(true)); } }); frag.appendChild(w); }
    });
    el.innerHTML=''; el.appendChild(frag);
    [].slice.call(el.querySelectorAll('.w')).forEach(function(w,i){ w.style.transitionDelay=Math.min(i*0.05,0.6)+'s'; });
    el.classList.add('wsplit');
  }
  var ho=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('lit'); ho.unobserve(e.target); } }); },{threshold:.3});
  [].slice.call(document.querySelectorAll('.sec__h, .reviews__h, .uses__h, .bundle__h, .blg__h, .founder__txt h2')).forEach(function(h){ splitH(h); ho.observe(h); });
})();

/* ===== intro cinematografico: rimozione dopo la sequenza (una volta a sessione, skip al click) ===== */
(function(){
  var intro=document.querySelector('.olio-intro'); if(!intro) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var seen=null; try{ seen=sessionStorage.getItem('olioIntro'); }catch(e){}
  if(reduce || seen){ if(intro.parentNode) intro.parentNode.removeChild(intro); return; }
  document.documentElement.classList.add('intro-lock');
  var done=false;
  var lift=function(){ if(done) return; done=true; intro.classList.add('done'); document.documentElement.classList.remove('intro-lock'); try{ sessionStorage.setItem('olioIntro','1'); }catch(e){} setTimeout(function(){ if(intro.parentNode) intro.parentNode.removeChild(intro); }, 950); };
  var t=setTimeout(lift, 1900);
  intro.addEventListener('click', function(){ clearTimeout(t); lift(); });
})();

/* ===== Smooth scroll cinematografico (solo desktop) =====
   Inerzia/lerp sulla rotella, sopra lo scroll NATIVO (window.scrollTo per-frame):
   scrollY resta veritiero -> myth pinnato, parallax, filo conduttore e header restano sincronizzati.
   La tastiera e i link ancora restano morbidi via CSS (scroll-behavior:smooth); i nostri frame usano
   behavior:'instant' per non raddoppiare l'animazione. Disattivo su touch/mobile e reduced-motion,
   e mi tiro indietro sui contenitori con scroll interno e quando un modale blocca lo scroll. */
(function(){
  var mq = window.matchMedia; if(!mq) return;
  if(mq('(prefers-reduced-motion:reduce)').matches) return;
  if(!mq('(hover:hover) and (pointer:fine)').matches) return;   // niente touch
  if(window.innerWidth < 1024) return;

  var TAU = 0.12;                 // morbidezza: piu' alto = piu' cinematografico/lento
  var target = window.scrollY, current = target;
  var running = false, lock = false, lastT = 0;

  function maxScroll(){ return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
  function clamp(v){ return Math.max(0, Math.min(v, maxScroll())); }
  function blocked(){ return document.body.style.overflow === 'hidden'
    || document.documentElement.classList.contains('intro-lock'); }
  function setTop(v){ window.scrollTo({ top: Math.round(v), left: 0, behavior: 'instant' }); }

  function frame(t){
    if(!lastT){ lastT = t; }
    var dt = Math.min(0.05, (t - lastT) / 1000); lastT = t;
    var a = 1 - Math.exp(-dt / TAU);
    current += (target - current) * a;
    if(Math.abs(target - current) < 0.4){ current = target; setTop(current); running = false; lock = false; lastT = 0; return; }
    setTop(current);
    requestAnimationFrame(frame);
  }
  function start(){ if(!running){ running = true; lastT = 0; requestAnimationFrame(frame); } }

  function innerScrollable(node){
    while(node && node.nodeType === 1 && node !== document.body){
      if(node.scrollHeight > node.clientHeight){
        var oy = getComputedStyle(node).overflowY;
        if(oy === 'auto' || oy === 'scroll') return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  window.addEventListener('wheel', function(e){
    if(e.ctrlKey) return;                 // pinch-zoom
    if(blocked()) return;                 // modale/drawer aperto -> nativo
    if(innerScrollable(e.target)) return; // popup/drawer con scroll proprio
    var dy = e.deltaY;
    if(e.deltaMode === 1) dy *= 16;                    // righe -> px
    else if(e.deltaMode === 2) dy *= window.innerHeight; // pagine -> px
    e.preventDefault();
    lock = true;
    target = clamp((running ? target : window.scrollY) + dy);
    start();
  }, { passive: false });

  // scroll non-rotella (tastiera, drag scrollbar, scrollIntoView): risincronizzo il target
  window.addEventListener('scroll', function(){ if(!running && !lock){ target = current = window.scrollY; } }, { passive: true });
  window.addEventListener('resize', function(){ target = clamp(target); if(!running) current = window.scrollY; });
})();

/* ===== Abbinatore "Buono su tutto": scorrimento automatico dei piatti =====
   Avanza da solo ogni ~3.8s; l'interazione manuale (click su un cibo) fa ripartire il timer;
   in pausa quando la sezione non e' in vista; disattivato con reduced-motion. */
(function(){
  var radios = [].slice.call(document.querySelectorAll('.pair__radio'));
  if(radios.length < 2) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var i = radios.findIndex(function(r){ return r.checked; }); if(i < 0) i = 0;
  var timer = null;
  function advance(){ i = (i + 1) % radios.length; radios[i].checked = true; }
  function start(){ stop(); timer = setInterval(advance, 3800); }
  function stop(){ if(timer){ clearInterval(timer); timer = null; } }
  radios.forEach(function(r, idx){ r.addEventListener('change', function(){ i = idx; start(); }); }); // click utente -> riparte il timer
  var sec = document.querySelector('.pair');
  if(sec && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) start(); else stop(); }); }, { threshold: 0.25 }).observe(sec);
  } else { start(); }
})();

/* HERO — avvio affidabile: forza play appena possibile (autoplay muted) e agancia il video sul poster senza scatti.
   (Lo swap 2K e' stato rimosso: causava un reload = "il video deve caricare". Sorgente unica 1920, alta qualita'.) */
(function(){
  var v = document.querySelector('.hero__video'); if(!v) return;
  var tryPlay = function(){ var p = v.play && v.play(); if(p && p.catch) p.catch(function(){}); };
  if(v.readyState >= 2) tryPlay();
  v.addEventListener('canplay', tryPlay, { once:true });
  v.addEventListener('loadeddata', function(){ v.classList.add('is-ready'); }, { once:true });
  // se l'autoplay e' stato bloccato, riprova al primo gesto
  ['pointerdown','touchstart','keydown'].forEach(function(ev){ window.addEventListener(ev, tryPlay, { once:true, passive:true }); });
})();

/* ===== IL MITO — "L'oro liquido": l'olio dorato sale riempiendo la frase allo scroll ===== */
(function(){
  var sec = document.querySelector('.oilstory'); if(!sec) return;
  var pin = sec.querySelector('.oilstory__pin'); if(!pin) return;
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce){ pin.style.setProperty('--surface','-9%'); return; }
  var ticking = false;
  function upd(){
    var total = sec.offsetHeight - window.innerHeight;
    if(total <= 0){ pin.style.setProperty('--surface','-9%'); return; }
    var p = -sec.getBoundingClientRect().top / total;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    var e = p*p*(3-2*p);            /* smoothstep: riempimento morbido */
    var surface = (1-e)*118 - 9;    /* p0 -> 109% (vuoto) ; p1 -> -9% (colmo) */
    pin.style.setProperty('--surface', surface.toFixed(2)+'%');
  }
  window.addEventListener('scroll', function(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ upd(); ticking=false; }); } }, { passive:true });
  window.addEventListener('resize', upd);
  upd();
})();

/* ===== routing reale: /products/<id>, /pages/collezione, /pages/chi-siamo, /blogs/diario[/<slug>] =====
   Ogni prodotto/pagina/articolo e' una risorsa Shopify vera con un template dedicato che carica
   questa stessa sezione: un caricamento diretto (Google, link condiviso) mostra la SPA gia' sulla
   pagina giusta, non sempre la home. Qui si decide SOLO quale "pagina" interna aprire all'avvio e
   quando il tasto indietro/avanti del browser cambia URL — go()/openProduct()/openArticle() fanno
   gia' tutto il resto (pushState incluso). */
function routeFromLocation(){
  const path=location.pathname.replace(/\/+$/,'')||'/';
  if(path==='/'){ return; } /* l'HTML parte gia' su home */
  let m=path.match(/^\/products\/([^/]+)$/);
  if(m && PRODUCTS[m[1]]){ openProduct(m[1]); return; }
  m=path.match(/^\/blogs\/diario\/([^/]+)$/);
  if(m && ARTICLES[m[1]]){ if(window.openArticle) window.openArticle(m[1]); return; }
  if(path==='/blogs/diario'){ go('blog','/blogs/diario'); return; }
  if(path==='/pages/collezione'){ go('shop','/pages/collezione'); return; }
  if(path==='/pages/chi-siamo'){ go('about','/pages/chi-siamo'); return; }
  if(path==='/pages/contact'){ go('contact','/pages/contact'); return; }
  /* /collections/* e /search sono URL veri di Shopify che il tema fa rendere da olio-home:
     la SPA non ha una griglia-collezione ne' una ricerca, e con soli tre oli la pagina "shop"
     e' esattamente quello che l'utente cercava. Meglio atterrare li' che sulla home muta. */
  if(/^\/collections(\/|$)/.test(path) || path==='/search'){ go('shop','/pages/collezione'); return; }
  /* URL riconosciuto da Shopify ma non da nessuna pagina interna (es. il bundle /products/il-rituale-completo,
     che non ha una sua scheda nella SPA): ripiega sulla collezione invece di restare sulla home muta. */
  if(/^\/products\//.test(path)) go('shop','/pages/collezione');
}
routeFromLocation();
/* al boot "/" non fa nulla perche' l'HTML nasce gia' su home; ma se il tasto indietro TORNA a "/"
   dopo aver aperto un prodotto/articolo, la pagina visibile va rimessa su home esplicitamente. */
window.addEventListener('popstate',function(){
  suppressPush=true;
  const path=location.pathname.replace(/\/+$/,'')||'/';
  if(path==='/') go('home','/'); else routeFromLocation();
  suppressPush=false;
});
